const arLang = {
    job_card_invoice_open_failed: "تعذر فتح نموذج الفاتورة. حاول مرة أخرى؛ لم يتم إنشاء أي فاتورة.",
    quotation_item_type_unclassified: "يجب مراجعة وتصنيف بنود عرض السعر القديم قبل تحويله إلى فاتورة أو بطاقة عمل. تم الاحتفاظ بالبنود دون تغيير.",
    contract_loading: "جارٍ تحميل العقد…",
    contract_load_failed: "تعذر تحميل العقود. تم الاحتفاظ بآخر نتيجة مؤكدة.",
    status_settings: "إعدادات الحالات",
    status_category: "القائمة",
    status_code: "الرمز",
    status_name_ar: "الاسم العربي",
    status_name_en: "الاسم الإنجليزي",
    status_include_archived: "إظهار المؤرشف",
    status_archived: "مؤرشف",
    status_active: "نشط",
    status_archive: "أرشفة",
    status_restore: "استعادة",
    status_workflow_protected: "حالة أساسية محمية",
    status_archive_confirm: "هل تريد أرشفة هذه الحالة؟ سيتم الاحتفاظ باسمها وسجلها ويمكن استعادتها.",
    status_restore_confirm: "هل تريد استعادة هذه الحالة؟",
    status_no_results: "لا توجد حالات في هذه القائمة.",
    status_loading: "جارٍ تحميل الحالات…",
    status_saving: "جارٍ الحفظ…",
    status_saved: "تم حفظ الحالة والتحقق منها.",
    status_save_failed: "تعذر حفظ الحالة. تم الاحتفاظ بالبيانات لإعادة المحاولة.",
    status_load_failed: "تعذر تحميل الحالات. تم الاحتفاظ بآخر قائمة مؤكدة.",
    status_filter_invalid: "بيانات القائمة أو المعرف غير صالحة.",
    status_names_invalid: "أدخل الاسمين العربي والإنجليزي بما لا يتجاوز 255 حرفاً.",
    status_color_invalid: "اختر ألواناً صحيحة.",
    status_points_invalid: "أدخل نقاطاً بين صفر ومليون، حتى ست خانات عشرية.",
    status_busy: "يجري تعديل القائمة. أعد المحاولة.",
    status_access_denied: "ليس لديك صلاحية تعديل هذه القائمة.",
    status_not_found: "الحالة غير موجودة في القائمة المحددة.",
    status_legacy_names_missing: "هذه حالة محذوفة قديمة. أدخل أسماءها الصحيحة قبل الاستعادة.",
    status_points_per_100: "النقاط لكل 100 ريال",

    spare_request_invalid_bill: "أدخل رقم سجل فاتورة شراء صحيحاً أو اتركه فارغاً.",
    spare_request_action_failed: "تعذر حفظ الإجراء. تحقق من حالة الطلب ورقم سجل فاتورة الشراء في هذا الفرع ثم أعد المحاولة.",
    spare_request_load_failed: "تعذر تحميل طلبات القطع. تم الاحتفاظ بآخر قائمة مؤكدة.",
    supervisor_report_empty: "لا توجد نتائج ضمن الفترة والمشرف المحددين.",
    supervisor_report_filter_invalid: "اختر تاريخ بداية ونهاية صحيحين ومشرفاً صالحاً.",
    supervisor_report_load_failed: "تعذر تحميل تقرير المشرف. تم الاحتفاظ بآخر نتيجة مؤكدة.",
    inspection_conversion_failed: "تعذر فتح نموذج التحويل. تحقق من بيانات العميل ثم حاول مرة أخرى.",
    inspection_load_failed: "تعذر تحميل الفحص. أعد المحاولة.",
    inspection_save_failed: "تعذر حفظ الفحص. تحقق من البيانات ثم أعد المحاولة.",
    inspection_queued: "في قائمة الإرسال",
    inspection_queued_on: "آخر طلب إرسال",
    inspection_queue_failed: "تعذر إدراج الفحص في قائمة الإرسال. تحقق من رقم العميل وقالب الرسالة.",

    server_not_responding: 'تعذر إكمال الطلب. حاول مرة أخرى.',
    whatsapp_provider_unavailable: 'تعذر التحقق من اتصال واتساب. حاول مرة أخرى لاحقاً.',
    whatsapp_request_failed: 'تعذر إكمال طلب واتساب. تحقق من البيانات ثم حاول مرة أخرى.',
    event_type: "الحدث",
    session: "جلسة الاتصال",
    last_check: "آخر تحقق",
    connect_whatsapp: "مسح رمز اتصال واتساب",
    reconnect: "إعادة اتصال واتساب",
    message_log: "سجل الرسائل",
    available_variables: "المتغيرات المتاحة",
    attempts: "المحاولات",
    wa_event_new_invoice: "فاتورة جديدة",
    wa_event_new_quotation: "عرض سعر جديد",
    wa_event_new_customer: "عميل جديد",
    wa_event_new_card: "أمر عمل جديد",
    wa_event_card_ready: "جاهز للتسليم",
    wa_event_card_closed: "أمر عمل مغلق",
    wa_event_update_card: "تحديث أمر عمل",
    wa_event_invoice_followup: "متابعة فاتورة",
    wa_event_oil_change_followup: "متابعة تغيير زيت",
    wa_event_owner_daily_summary: "ملخص إغلاق اليوم (المالك)",

    profit_report_filter_invalid: "اختر تاريخ بداية ونهاية صحيحين ومشرفاً صالحاً.",
    profit_report_load_failed: "تعذر تحميل تقرير الأرباح. تم الاحتفاظ بآخر نتيجة مؤكدة.",
    profit_report_supervisor_note: "تظهر الفواتير المستقلة عند اختيار الكل لعدم وجود مشرف مبيعات مرتبط بها.",

    work_report_load_failed: "تعذر تحميل تقرير العمل. تحقق من التواريخ ثم حاول مرة أخرى.",
    work_report_totals_note: "تُحتسب قيمة الخدمة مرة واحدة في الإجمالي عند إسنادها لأكثر من فني. تشير الشرطة إلى ساعات غير مسجلة.",

    purchase_return_source_rows_only: "يجب ربط المرتجع بسطور فاتورة الشراء الأصلية. عدّل كميات المرتجع ثم احفظ.",
    purchase_return_stock_invalid: "لا تكفي كمية المخزون أو قيمته لإجراء هذا المرتجع. راجع حركة الصنف.",
    purchase_return_quantity_invalid: "أدخل كمية مرتجعة موجبة لا تتجاوز الكمية المتبقية من المشتريات.",
    purchase_return_source_unposted: "يجب ترحيل فاتورة الشراء الأصلية قبل إنشاء المرتجع.",
    purchase_return_source_invalid: "تحتاج بيانات فاتورة الشراء الأصلية إلى مراجعة قبل إرجاعها.",
    purchase_return_source_journal_invalid: "يحتاج قيد فاتورة الشراء الأصلية إلى مراجعة قبل إرجاعها.",
    purchase_return_source_link_missing: "لا يرتبط هذا المرتجع القديم بسطور الشراء بشكل موثوق. راجعه قبل تعديله.",
    purchase_return_has_later_returns: "يجب إلغاء ترحيل المرتجعات اللاحقة لنفس سطور الشراء أولاً.",
    purchase_return_request_changed: "تم حفظ هذا الطلب مسبقاً ببيانات مختلفة. حدّث قائمة المرتجعات قبل إنشاء مرتجع جديد.",
    purchase_return_request_required: "أعد فتح نموذج المرتجع وحاول مرة أخرى.",
    purchase_return_write_failed: "لم يتم حفظ المرتجع. تم الاحتفاظ بالبيانات لإعادة المحاولة.",
    post_purchase_return_note: "إلغاء ترحيل المرتجع يعيد المخزون وكميات الفاتورة الأصلية ويعكس القيد المحاسبي والمبلغ المسترد المرتبط به. هل تريد المتابعة؟",

    purchase_action_failed: "تعذر تأكيد نجاح العملية. حدّث الصفحة للتحقق ثم أعد المحاولة.",
    purchase_load_failed: "تعذر تحميل فواتير المشتريات. يرجى إعادة المحاولة.",
    purchase_account_mapping_required: "يرجى مراجعة ربط حسابات المشتريات قبل الترحيل.",
    purchase_has_returns: "لا يمكن تعديل ترحيل فاتورة لها مرتجعات.",
    purchase_has_later_stock_movements: "توجد حركات مخزون لاحقة. يجب عكسها قبل إلغاء ترحيل هذه الفاتورة.",
    purchase_stock_history_missing: "يتطلب إلغاء الترحيل مراجعة حركة المخزون الأصلية لهذا المستند.",
    purchase_state_changed: "تغيرت حالة الفاتورة. حدّث الصفحة للتحقق.",
    catalogue_load_failed: "تعذر تحميل قائمة الأصناف. يرجى إعادة المحاولة.",
    report_export_failed: 'تعذر إنشاء التقرير. يرجى إعادة المحاولة.',
    addes_successfuly: 'تمت الاضافة بنجاح',
    chose_from_list: 'اختر',
    refresh: 'تحديث',
    add_note: 'إضافة ملاحظة',
    photo_gallery: 'معرض الصور',
    warnings: 'التنبيهات',
    add_warning: 'إضافة تنبيه',
    send_whatsapp: 'ارسال واتس اب',
    select_template: 'اختر القالب',
    template_vars_required: 'يجب عليك تعبئة جميع الحقول الخاصة بمتغيرات القالب',
    template_required: 'يجب اختيار قالب',
    whatsapp_mobile_required: 'يجب ان يكون رقم الاتصال معرف كواتس اب ولا يكون فارغا',
    add_car: 'اضافة سيارة',
    expenses: 'المصروفات',
    view_request: 'استعراض',
    sent_date: 'تاريخ الارسال',
    received_date: 'تاريخ الاستلام',
    return_date: 'تاريخ الارجاع',
    returned_by_receipt: 'ارجاع بواسطة الاستلام',
    sent_qty: 'الكمية المرسلة',
    sent_total: 'الاجمالي المرسل',
    received_qty: 'الكمية المستلمة',
    received_total: 'الاجمالي المستلم',
    returned_qty: 'الكمية المرتجعة',
    returned_total: 'اجمالي المرتجع',
    cancel: 'الغاء',
    support_terms_title: 'شروط السداد',
    support_terms_label: 'شروط واحكام الدعم الفني',
    field_required: 'هذا الحقل مطلوب',
    add_customer: 'إضافة عميل',
    activity: 'النشاط',
    points: 'النقاط',
    system_type: 'نوع النظام',
    provide_devices: 'توفير أجهزة',
    total_price: 'اجمالي السعر',
    file_type: 'نوع الملف',
    attachment: 'مرفق',
    edit: 'تعديل',
    comments: 'التعليقات',
    operating_costs: 'التكاليف التشغيلية',
    operating_expenses: 'المصاريف التشغيلية',
    sold_items: 'الاصناف المباعة',
    advertising_campaign: 'الحملة الاعلانية',
    advertising_campaigns: 'الحملات الاعلانية',
    request_approval: 'طلب تعميد',
    ad_location: 'مكان الاعلان',
    expected_cost: 'التكلفة المتوقعة',
    approvals: 'التعميدات',
    request_date: 'تاريخ الطلب',
    sender: 'المرسل',
    approved_date: 'تاريخ التعميد',
    approved_by: 'التعميد بواسطة',
    specifications: 'المواصفات',
    cost: 'التكلفة',
    ad_materials: 'المواد الاعلانية',
    view_project: 'استعراض مشروع',
    order_number: 'رقم الطلب',
    issue_version: 'اصدار نسخة',
    invoice: 'فاتورة',
    print_invoice: 'طباعة الفاتورة',
    customer_info: 'معلومات العميل',
    company_or_entity: 'الشركة/المؤسسة',
    trade_name: 'الاسم التجاري',
    order_info: 'معلومات الطلب',
    order_status: 'حالة الطلب',
    agent_commission: 'عمولة المندوب',
    products: 'المنتجات',
    product_name: 'اسم المنتج',
    quotation: 'عرض سعر',
    quotations: 'عروض السعر',
    quotation_number: 'رقم العرض',
    terms_and_conditions: 'الشروط والأحكام',
    include: 'تضمين',
    payment_terms: 'شروط واحكام السداد',
    delivery_terms: 'شروط واحكام التركيب والتوصيل',
    support_terms: 'شروط واحكام الدعم الفني',
    requirements_terms: 'متطلبات يجب توفيرها من قبل العميل',
    scope_of_work: 'نطاق العمل',
    signature_type: 'نوع التوقيع',
    sign_in: 'توقيع الدخول',
    sign_out: 'توقيع الخروج',
    out_of_scope: 'خارج نطاق العمل',
    payment_methods: 'طرق السداد',
    task: 'المهمة',
    responsible: 'المسؤول',
    deadline: 'الموعد النهائي',
    close_date: 'تاريخ الاغلاق',
    closed_by: 'اغلاق بواسطة',
    support_request_description: 'وصف طلب الصيانة',
    view_customer: 'استعراض عميل',
    add_task: 'اضافة مهمة',
    add_product: 'اضافة منتج',
    add_job_order: 'اضافة امر تشغيل',
    job_order_number: 'رقم امر التشغيل',
    car_entry_date: 'تاريخ دخول السيارة',
    program_features: 'مميزات البرنامج',
    resend: 'اعادة ارسال',
    stop_campaign: 'ايقاف الحملة',
    campaign_data: 'بيانات الحملة',
    whatsapp_campaign: 'حملة الواتس',
    statistics: 'احصائيات',
    customers_count: 'عدد العملاء',
    read_count: 'تمت القراءة',
    response_count: 'تمت الاستجابة',
    buyers_count: 'عدد المشترين',
    top_city_purchase: 'اكثر المدن شراء',
    top_city_followup: 'اكثر المدن متابعة',
    riyadh: 'الرياض',
    dammam: 'الدمام',
    responded_customers: 'عملاء قامو بالرد',
    response_date: 'تاريخ الاستجابة',
    last_message: 'أخر رسالة',
    send_reply: 'ارسال رد',
    purchased_customers: 'عملاء قامو بالشراء',
    purchase_date: 'تاريخ الشراء',
    invoice_number: 'رقم الفاتورة',
    send_invoice: 'ارسال الفاتورة',
    returned_items: 'الاصناف المرتجعة',
    price_with_vat: 'السعر شامل الضريبة',
    returned_price_with_vat: 'سعر المرتجع شامل الضريبة',
    add_sms_message: 'إضافة رسالة SMS',
    message_customers: 'مراسلة العملاء',
    select_customer: 'اختر العميل',
    car_customers: 'عملاء السيارات',
    billing_customers: 'عملاء الفوترة',
    normal_message: 'رسالة عادية',
    stop_customer_version: 'ايقاف نسخة العميل',
    reactivate_customer: 'اعادة تفعيل العميل بعد الايقاف',
    empty_message_error: 'لا يمكن ارسال رسالة فارغة',
    sms_send_success: 'تم الارسال بنجاح ستظهر الرسالة لدى العملاء خلال الخمس دقائق القادمة',
    sms_send_error: 'حدث خطأ بالارسال',
    success: 'نجاح',
    error: 'خطأ',
    item_not_available: 'الصنف غير متوفر او الصنف خدمي',
    quantity_not_zero: 'الكمية يجب ان تكون رقم غير الصفر',
    add_item_without_name: 'لا يمكن اضافة صنف بدون اسم',
    support_description_required: 'يجب ان تقوم باضافة وصف الدعم الفني',
    support_ticket_updated_successfully: 'تم تعديل تذكرة الدعم بنجاح',
    old_messages: 'الرسائل القديمة',
    or_upload_file: 'أو بإمكانك تحميل ملف',
    message_text_required: 'نص الرسالة مطلوب دائما',
    message_title_required: 'عنوان الرسالة مطلوب دائما',
    number_list_required: 'يجب اضافة رقم على الاقل لقائمة الارقام',
    image_title_required: 'يجب اضافة عنوان الصورة',
    document_title_required: 'يجب اضافة عنوان المستند',
    video_title_required: 'يجب اضافة عنوان الفيديو',
    message_queued_notice: 'تمت اضافة الرسالة إلى قائمة الرسائل - تعتمد مدة الارسال على عدد الارقام',
    item_code_required: 'رقم الصنف مطلوب دائما',
    item_price_required: 'يجب اضافة سعر للصنف قبل الاضافة',
    item_already_exists: 'الصنف موجود مسبقا .. يرجى التأكد',
    item_not_found_add_card: 'الصنف غير موجود يرجى اضافة كرت الصنف اولا',
    item_code_required_for_non_existing: 'لا يمكن اضافة صنف غير موجود - رمز الصنف دائما مطلوب',
    return_qty_exceeds_allowed: 'لا يمكن ارجاع اصناف اكبر من الكمية المتاحه وهي: ',
    qty_must_be_nonzero: 'الكمية يجب انت تكون رقم غير الصفر',
    item_name_required: 'لا يمكن اضافة صنف بدون اسم',
    item_price_nonzero: 'يجب أن يكون سعر الصنف رقما غير صفر',
    invoice_number_required: 'رقم الفاتورة مطلوب دائما',
    vendor_data_required: 'يجب تعبئة بيانات المورد قبل اضافة الفاتورة',
    no_matching_invoice: 'لا يوجد فاتورة مطابقة .. يرجى التاكد والتجربة مره اخرى - أو ان الفاتورة تم ارجاعها',
    internal_invoice: 'فاتورة داخلية',
    non_buying_customers: 'العملاء غير مشترين',
    buying_customers: 'العملاء المشترين',
    expired_customers: 'العملاء المنتهيين',
    no_row_selected: 'لم يتم تحديد اي صف',
    selected_deleted: 'تم حذف المحدد',
    selected_returned: 'تم ارجاع المحدد',
    invoice_returned: 'تم ارجاع الفاتورة',
    invoice_deleted_success: 'تم حذف الفاتورة بنجاح',
    return_items_selection_required: 'لم تقم باختيار الاصناف التي ترغب بارجاع جزء او كامل الكمية يرجى اختيار صنف على الاقل',
    invoice_issued: 'تم اصدار الفاتورة',
    unknown_customer: 'عميل غير مدرج',
    note_required: 'يجب ان تقوم باضافة ملاحظة',
    procedure_updated_successfully: 'تم تعديل الاجراء بنجاح',
    vacations: 'الاجازات',
    your_vacation_limit_is_overdue: 'عدد الايام المدخل اكثر من ايام الاجازة المسموحه لك',
    vacation_reasons_required: 'سبب الاجازة مطلوب',
    vacation_start_date_required: 'تاريخ بدء الاجازة مطلوب',
    vacation_remains: 'المتبقي من الاجازة',
    vacation_reasons: 'سبب الاجازة',
    calnder_all_field_required: 'جميع الحقول الخاصة بحجز الموعد مطلوبة',
    customer_support: 'الدعم الفني',
    all_total: "اجمالي المطلوب",
    sales_total: 'اجمالي المبيعات',
    sales_ftotal: 'اجمالي المبيعات مع الضريبة',
    afforded_customer_name: 'عميل التأمين',
    customer_afforded: 'تحمل العميل',
    view_subscriber: 'عرض الاشتراك',
    view_offer: 'كرت العرض',
    all_branches: 'كل الفروع',
    created_date: 'تاريخ الاضافة',
    campaign_profit: 'الدخل',
    campaign_clients: 'عدد العملاء',
    campaign_cost: 'تكلفة البرنامج',
    campaign_target: 'العدد المستهدف',
    campaign_branches: 'الفروع المستهدفة',
    campaign_end: 'تاريخ نهاية العرض',
    vehicle_type: 'نوع المركبة',
    campaign_area: 'المنطقة المستهدفة',
    all_regions: 'كل المدن',
    exact_city: 'مدينة محددة',
    FixedAssets: 'الاصول الثابتة',
    return_quotation: 'تفعيل العرض',
    campaign_price: 'سعر العرض',
    add_title: 'اضافة بنود العقد',
    title_cond: 'البند',
    updatePeriodMaint: 'تعدل الصيانة الدورية',
    period_maint: 'صيانة دورية',
    maint_prog: 'برامج الصيانة',
    maint_contract: 'عقود صيانة',
    number_of_days: 'عدد الايام',
    add_vacation: 'اضافة اجازة',
    po_number: 'رقم المطالبة/الحالة',
    visit_type: 'نوع الزيارة',
    last_visit: 'آخر زيارة',
    add_periodic_maint: "أضافة صيانة",
    select_store: 'اختر المستودع',
    inventory_report: 'تقرير الجرد',
    coa_report: 'تقرير الدليل',
    coa_report_with_totals: 'تقرير الدليل بالمجاميع',
    parent_class_name: 'اسم الحساب الرئيسي',
    parent_classid: 'الحساب الرئيسي',
    deleted_successfuly: 'تم الحذف بنجاح',
    this_item_used_you_can_not_delete_it: 'العنصر المراد حذفه مستخدم، ولا يمكن حذفه',
    pnl_report: 'تقرير قائمة الدخل',
    hide_zero_accounts: 'اخفاء المجاميع الصفرية',
    trial_balance : 'ميزان المراجعة',
    trial_in_balances: 'الميزان بالارصدة',
    trial_in_totals: 'الميزان بالمجاميع',
    attend_late: 'تاخير حضور',
    left_early: 'انصراف مبكر',
    not_attend: 'غياب',
    select_year: 'اختر السنة',
    select_month: 'اختر الشهر',
    update_add_employee_success: "تمت اضافة / تعديل الموظف بنجاح",
    employee_name_required: 'اسم الموظف مطلوب',
    mobile_number_required: 'رقم الجوال مطلوب',
    base_salary_required: 'الراتب الاساسي مطلوب',
    finger_print_id: 'رقم تعريف البصمة',
    unit_name: 'اسم الوحدة',
    sale_price: 'سعر البيع',
    minimum_salse_price: 'الحد الادنى للبيع',
    maximum_salse_price: 'الحد الاعلى للبيع',
    salesable: 'قابل للبيع',
    none_salesable: 'غير قابل للبيع',
    final_product: 'منتج نهائي',
    raw_material: 'مواد خام',
    assembly_product: 'تجميعي',
    assembly_components: 'مكونات المنتج التجميعي',
    add_material: 'إضافة مادة',
    select_material: 'اختر المادة',
    assembly_components_required: 'يجب إضافة مادة واحدة صالحة على الأقل للمنتج التجميعي.',
    product_save_failed: 'تعذر حفظ الصنف .. يرجى المحاولة مرة اخرى او التواصل مع الدعم الفني',
    required_assembly_components: 'المواد الإلزامية',
    optional_assembly_components: 'المواد الاختيارية',
    optional_assembly_components_help: 'يمكن للعميل اختيار هذه المواد عند إضافة المنتج التجميعي إلى الطلب.',
    add_optional_material: 'إضافة مادة اختيارية',
    choose_optional_materials: 'اختر المواد الاختيارية',
    add_assembly_to_order: 'إضافة المنتج التجميعي للطلب',
    assembly_components_save_failed: 'تعذر حفظ مواد المنتج التجميعي',
    factory_item: 'منتج مصنع',
    return_selected: 'ارجاع المحدد',
    delete_selected: 'حذف المحدد',
    delete_invoice: 'حذف الفاتورة',
    edit_voucher: 'تعديل السند',
    add_out_voucher: 'اضافة سند صرف',
    please_add_qtty: 'يرجى اضافة الكمية',
    please_add_purchase_price: 'يرجى اضافة سعر الشراء',
    please_add_purchase_date: 'يرجى اضافة تاريخ الشراء',
    plase_add_assets_ar_name: 'يرجى ادخال اسم الاصل بالعربي',
    plase_add_assets_en_name: 'يرجى ادخال اسم الاصل بالانجليزي',
    fixed_assets_namear: 'اسم الاصل بالعربي',
    fixed_assets_nameen: 'اسم الاصل بالانجليزي',
    add_fixed_assets: 'إضافة اصل ثابت',
    udpate_fixed_assets: 'تعديل اصل ثابت',
    purchase_price: 'سعر الشراء',
    depreciation_rate: 'نسبة الاهلاك',
    depreciation_period: 'مدة الاهلاك',
    depreciation_amount: 'قيمة الاهلاك',
    current_price: 'السعر الحالي',
    error_date: 'تاريخ القيد خارج نطاق السنة المالية الحالية يرجى اختيار التاريخ المناسب',
    update_journal:'تعديل القيد',
    add_new_journal: 'اضافة قيد',
    gov_expenses: 'مصروفات حكومية',
    debit: 'مدين',
    analyses_account:'حساب تحليلي',
    main_account: 'حساب فرعي',
    balance_type: 'ميزانية',
    bnl_type: 'ارباح وخسائر',
    income_type: 'إيرادات',
    other_type: 'أخرى',
    add_sub_account: 'اضافة حساب فرعي',
    sub_accounts: 'الحسابات الفرعية',
    note_text_required: 'يرجى اضافة نص الملاحظة',
    card_paid_status: 'حالة السداد',
    card_paid: "مسدد",
    card_not_paid: "غير مسدد",
    is_saleable: 'هل المنتج قابل للبيع',
    product_namear: "اسم المنتج بالعربي",
    product_nameen: "اسم المنتج بالانجليزي",
    no_account_ar: 'بدون حساب',
    unit_namear: 'اسم الوحده بالعربي',
    unit_nameen: 'اسم الوحده بالانجليزي',
    profit: 'الارباح',
    wins: 'صافي الربح',
    costs: 'التكاليف',
    available_qtty: 'الكمية المتاحة',
    transfer_qtty: 'الكمية المحولة',
    from_store: 'التحويل من',
    to_store: 'التحويل إلى',
    visit_oursite: 'زيارة مقرنا',
    vin: 'رقم الشاص',
    color: 'اللون',
    brand: 'الماركة',
    technical:'الفني',
    carstotal: 'عدد السيارات',
    item_totals: 'عدد الاصناف',
    created_by: 'انشأت بواسطة',
    card_supervisor: 'الفني',
    company_name_and_company_address_required: 'اسم الشركة والعنوان دائما مطلوبين',
    please_add_one_item_before_continue: 'يرجى اضافة صنف واحد على الاقل',
    select_store_before_continue: 'يرجى اختيار المستودع',
    temporary_expenses: 'مصروفات مستردة',
    years: 'السنوات',
    renew: 'تجديد',
    renewal_amount: 'التجديد السنوي',
    successfuly_job: 'تمت العملية بنجاح',
    branches: 'الفروع',
    stores: 'المستودعات',
    taxes: 'الضرائب',
    call: 'اتصال',
    custoday_not_equal: "عهدة الموظف لا تغطي تكاليف الفاتورة",
    payment_method_error: "يجب اختيار طريقة دفع قبل المتابعة أو عهدة من موظف",
    empty_invoice_error: 'لا يمكن اضافة فاتورة فارغة',
    date_required: 'يرجى اختيار التاريخ',
    date_out_of_day: "تاريخ الفاتورة يجب ان لا يتجاوز التاريخ الحالي تم اعادة التاريخ إلى تاريخ اليوم",
    all_field_require: 'يرجى اكمال كافة الحقول المطلوبة',
    pay_more_than_price: "لا يمكن سداد مبلغ يتجاوز قيمة اجمالي الفاتورة",
    car_digit_4: "يجب أن تكون ارقام اللوحة مؤلفة من اربع ارقام",
    all_calr_plate_field_required: "يجب تعبئة حقول حروف اللوحة بالكامل",
    mobile_alert_10: "رقم الجوال يجب ان يكون من عشرة ارقام يبدأ برقم 05",

    error_no_qty: "الصنف المختار غير متوفر حاليا... يرجى اضافة فاتورة مشتريات قبل اضافة المخزون ليتم احتساب ضريبة القيمة المضافة بشكل صحيح",
    alert: 'تنبيه',
    notes_require: 'وصف التذكرة مطلوب دائما',
    times_require: 'يرجى اختيار وقت لتنفيذ التذكرة',
    deadline_require: 'تاريخ الانتهاء مطلوب دائما',
    executed_date_require: 'تاريخ التنفيذ مطلوب دائما',
    start_date_require: 'تاريخ البدء مطلوب دائما',
    subject_require: 'عنوات التذكرة مطلوب دائما',
    customer_require: 'يرجى اختيار العميل',
    department:'القسم',
    support_type: 'نوع الدعم',
    available_times: 'الاوقات المتاحة',
    service_name: 'نوع الدعم',
    source: 'المصدر',
    support_case: 'نوع الدعم',
    support_procedure: 'الاجراء المطلوب',
    executed_date: 'تاريخ التنفيذ',
    last_10_messages: 'آخر عشر رسائل',
    product: 'المنتج',
    working_time_star: 'بدء العمل',
    working_time_end: 'انتهاء العمل',
    send: 'إرسال',
    what_to_send: 'نوع الارسال',
    campaign_start: 'تاريخ بداية العرض',
    campaign_start_time: 'وقت البدء',
    campaign_title: 'اسم البرنامج',
    add_new: 'اضافة جديد',
    offer_name: '',
    offer_start: '',
    offer_end: '',
    add_offer: 'اضافة عرض',
    client_source: 'مصدر العميل',
    PublishMe: 'اصدار ترخيص',
    send_attachment: 'السماح بارسال ملفات',
    expire_date: 'تاريخ الانتهاء',
    api_token: 'كود تفعيل الواتس اب (للحصول على الكود الاتصال بـ 0595907777)',
    purchase_inv: 'فاتورة المشتريات',
    web_url: 'رابط النسخة',
    client_priority: 'الأهمية',
    erocedure_date: 'تاريخ الاجراء',
    procedure: 'الاجراء',
    update_procedures: 'تعديل الاجراء',
    saleable: 'قابل للبيع',
    is_finalProduct: 'نوع الصنف',
    vendor_code: 'رقم تعريف المورد',
    unit_type: 'نوع الوحدة',
    main_unit: 'الوحدة الاساسية',
    standard_minutes: 'الوقت القياسي (دقيقة)',
    customer_portal: 'بوابة العميل',
    technician_portal: 'بوابة الفني',
    coming_soon: 'قريباً',
    login_mobile_number: 'رقم الجوال',
    send_verification_code: 'إرسال رمز التحقق',
    verify_code: 'تحقق',
    resend_code: 'إعادة إرسال الرمز',
    my_profile: 'ملفي الشخصي',
    my_mobile_numbers: 'أرقام الجوال',
    main: 'رئيسي',
    make_main: 'جعله رئيسي',
    add_new_mobile: 'إضافة رقم جوال',
    no_jobs_assigned: 'لا توجد مهام مسندة إليك حالياً.',
    my_records: 'سجلاتي',
    visit_request: 'طلب زيارة',
    no_records: 'لا توجد سجلات.',
    download_pdf: 'تحميل PDF',
    accept_request: 'قبول الطلب',
    remaining: 'المتبقي',
    request_time: 'الوقت',
    request_note: 'ملاحظات',
    submit_request: 'إرسال الطلب',
    my_requests: 'طلباتي',
    service_requests_queue: 'قائمة طلبات العملاء',
    reject: 'رفض',
    pending: 'قيد الانتظار',
    confirmed: 'تم التأكيد',
    rejected: 'مرفوض',
    all: 'الكل',
    excellent: 'ممتاز',
    good: 'جيد',
    bad: 'سيء',
    rating: 'التقييم',
    start: 'بدء',
    pause: 'إيقاف مؤقت',
    finish: 'إنهاء',
    resume: 'استئناف',
    technician_ratings_dashboard: 'لوحة تقييم الفنيين',
    pause_reason: 'سبب الإيقاف المؤقت',
    job_history: 'السجل والمحادثة',
    write_a_message: 'اكتب رسالة...',
    loading: 'جارٍ التحميل...',
    system: 'النظام',
    history: 'السجل والمحادثة',
    add_photo: 'إضافة صورة',
    my_jobs: 'مهامي',
    update_units: 'تعديل وحدة',
    add_unit: 'إضافة وحدة',
    main_unit_ar: 'الوحدة الرئيسية عربي',
    main_unit_en: 'الوحدة الرئيسية انجليزي',
    unitId: 'المعرف',
    unit_piece: 'قطعه',
    unit_kilogram: 'كيلو جرام',
    old_invoice: 'الفاتورة السابقة',
    title: 'العنوان',
    expected_income: 'الدخل المتوقع',
    job_cards: 'اوامر التشغيل',
    job_card: 'كرت اصلاح',
    contracts: 'العقود',
    supports: 'الدعم',
    meter_car: 'قراءة العداد',
    contract_date: 'تاريخ العقد',
    contract_expire_date: 'تاريخ الانتهاء',
    contract_start_date: 'تاريخ البدء',
    cars_number: 'عدد السيارات',
    last_maint_by: 'اخر صيانة بواسطة',
    last_maint_date: 'تاريخ اخر صيانة',
    contract_id: 'رقم العقد',
    add_contract: 'إضافة عقد',
    start_qtty: 'الرصيد الافتتاحي',
    cost_price: 'سعر التكلفة',
    add_sinventory: 'إضافة مخزون',
    add_transfer: 'إضافة تحويل',
    trans_from: 'تحويل من',
    trans_to: 'تحويل إلى',
    trans_type: 'نوع التحويل',
    received_by: 'استلام بواسطة',
    account_number: 'رقم الحساب',
    store_name_ar: 'اسم المستودع عربي',
    store_name_en: 'اسم المستودع انجليزي',
    add_store: 'اضافة مستودع',
    card_type: 'نوع الصيانة',
    new_sales: 'كرت جديد',
    return_sales: 'كرت رجيع',
    mobile_required: 'رقم الاتصال مطلوب دائما',
    super_visor_required: 'يجب اختيار مشرف',
    superVisor: 'مشرف مبيعات',
    checklist: 'قائمة التحقق',
    task_title: 'عنوان المهمة',
    employee: 'الموظف',
    project_employees: 'موظفي المشروع',
    project_close_date: 'اغلاق المشروع',
    project_start: 'بداية المشروع',
    project_deadline: 'نهاية المشروع',
    project_owner: 'مسؤول المشروع',
    project_type: 'نوع المشروع',
    project_title: 'عنوان المشروع',
    support: 'الدعم الفني',
    industry: 'نوع العمل',
    day_name: 'اليوم',
    exeute_date: 'تاريخ التنفيذ',
    task_priority: 'الأهمية',
    companies: 'فواتير شركات',
    owner_name: 'مالك السيارة',
    add_work_order: 'اضافة امر عمل',
    work_order: 'أوامر العمل',
    employee_name: 'اسم الموظف',
    number_of_tasks: 'عدد المهام',
    closed_tasks: 'مغلق',
    canceled_tasks: 'ملغي',
    opened_tasks: 'تحت الاجراء',
    advanced_payment_deleted: 'تم حذف السلفة بنجاح',
    employee_deleted: 'تم حذف الموظف بنجاح',
    cannot_delete_this_vendor_invoices_found: 'المورد لديه فواتير مشتريات - مصروفات لا يمكن حذفه',
    cannot_delete_this_vendor_payment_found: 'هناك دفعات مسددة للمورد لا يمكن حذف المورد',
    vendor_delete_done: 'تم حذف المورد بنجاح',
    cannot_delete_this_customer_invoices_found: 'لا يمكن حذف عميل لديه فواتير',
    cannot_delete_this_customer_cards_found: 'لا يمكن حذف عميل لديه أوامر تشغيل',
    custoemr_delete_done: 'تم حذف العميل بنجاح',
    client_type: 'نوع العميل',
    message_title: 'عنوان الرسالة',
    image_url: 'رابط الصورة',
    document_url: 'رابط المستند',
    vedio_url: 'رابط الفيديو',
    number_list: 'قائمة الارقام',
    number_list_notes: 'ضع فاصلة بين الارقام',
    sent_type: 'نوع الارسال',
    send_to: 'ارسال إلى',
    send_date: 'تاريخ الارسال',
    message_type: 'نوع الرسالة',
    message_text: 'نص الرسالة',
    customer_number: 'عدد العملاء',
    sending_number: 'عدد المرسل لهم',
    media_link: 'عرض الملف',
    add_support: 'اضافة تذكرة',
    support_ticket: 'الدعم الفني',
    industrial: 'الصناعية',
    update_task: 'تحديث مهمة',
    task_updated_successfully: 'تم تعديل المهمة بنجاح',
    whats_type: 'نوع الرسالة',
    whats_url_multi: 'رابط - الصورة او المستند او الفديو',
    last_action_date: 'تاريخ اخر اجراء',
    yes_19: 'اضافة جهاز شاشة 19 انش',
    yes_24: 'اضافة جهاز شاشة 24 انش',
    no_devices: 'لا يوجد اجهزة',
    include_computers: 'اضافة اجهزة',
    copies: 'عدد التراخيص',
    license_url: 'رابط الترخيص',
    task_response: 'المسؤول',
    note_text: 'نص الملاحظة',
    note_type: 'نوع المالحظة',
    generate_license: 'اصدار ترخيص',
    view_crm: 'عميل محتمل',
    agent: 'المندوب',
    next_action_date: 'تاريخ الاجراء',
    next_action: 'الاجراء القادم',
    last_action: 'الاجراء السابق',
    last_update: 'اخر تحديث',
    job_order: 'أمر العمل',
    training: 'التدريب',
    task_type: 'نوع المهمة',
    // added_by: 'اضافة بواسطة',
    note_date: 'تاريخ الملاحظة',
    edit_calendar: 'تعديل الحجز',
    change_booking_date: 'تغيير الموعد',
    booking_procedure:'اجراءات الحجز',
    work_name: 'وصف الموعد',
    estimated_price: 'السعر التقريبي',
    choose_custoemr: "اختر العميل",
    calendar_table: 'جدول الحجوزات',
    cancel_card: 'الغاء البطاقة',
    ready_to_deliver: 'جاهز للتسليم',
    brand_name: 'الشركة المصنعة',
    add_new_status: 'اضافة حالة جديدة',
    carsnumber: 'عدد السيارات',
    work_type: 'نوع العمل',
    // item_name: 'اسم قطع الغيار',
    add_spare_part: 'اضافة قطع غيار',
    add_new_spare_part: 'اضافة قطع غيار',
    spare_part_item_code: 'رقم القطعة',
    ment_description: 'أعمال الصيانة',
    customer_status: 'حالة العميل',
    tasks_status: 'المهام',
    warantly_status: 'الضمان',
    calendar_status: 'الحجوزات',
    book_calendar: 'الحجوزات',
    start_time: 'توقيت البدء',
    deadline_time: 'توقيت الانتهاء',
    add_booking: 'اضافة حجز',
    start_time_required: 'توقيت البدء والانتهاء مطلوبين دائما',
    plate_number_required: 'يجب اختيار رقم اللوحة',
    add_warantly: 'اصلاح على الضمان',
    last_update_by: 'تحديث بواسطة',
    last_update_date: 'تاريخ اخر تحديث',
    closed_date: 'تاريخ الاغلاق',
    task_start_end_date_required: 'تاريخ البدء والانتهاء مطلوبين دائما',
    task_description_required: 'يجب اضافة وصف للمهمة',
    change_status: 'تغيير الحالة',
    task_actions: 'اجراءات المهام',
    hours_24: '24 ساعة',
    hours_48: '48 ساعة',
    hours_72: '72 ساعة',
    hours_96: '96 ساعة',
    task_to: 'تحويل الى',
    dead_line: 'تاريخ الانتهاء',
    task_description: 'وصف المهمة',
    tasks: 'المهام',
    financial_request: 'المطالبات المالية',
    report: 'تقرير',
    unpaid_job_orders: 'غير مفوتر',
    finance_report: 'الحركة المالية',
    add_notes: 'اضافة ملاحظة',
    cars: 'السيارات',
    add_fincance_request: 'مطالبة مالية',
    name_info_required: "اسم العميل مطلوب ويجب ان يكون اكثر من خمس احرف",
    mobile_info_required: 'رقم الاتصال يجب ان يكون اربع ارقام',
    mobile_info_required_fullmobile: 'رقم الاتصال مطلوب ويجب ان يبدأ بـ 05',
    add_your_cash: 'ادخل المبلغ النقدي هنا بحسب الفئات',
    book_tables: 'حجز طاولة',
    menu: 'القائمة',
    smiller_products: 'الاصناف المتشابهة',
    cashair: 'الكاشير',
    managment: 'الادارة',
    invoice_summary: 'ملخص الفاتورة',
    add_client_voucher: 'سداد عميل',
    total_payment_to_Client: 'المبلغ المستحق الدفع من العميل: ',
    client_appointment: 'حجز موعد',
    client_statement_pos: 'حساب عميل',
    total_payment_to_vendor: 'اجمالي الدفعات المتسحقة للمورد: ',
    clode_shift: 'اغلاق يومية',
    add_purchase: 'اضافة مشتريات',
    calendar: 'المواعيد',
    open_new_shift: 'فتح الوردية',
    opening_balance: 'الرصيد الافتتاحي',
    shift_already_open: 'هناك وردية اخرى قيد العمل الان',
    shift_started_by_other: 'هناك وردية بدأت العمل من قبل موظف آخر .. يرجى مراجعة الموظف واغلاق الورديه قبل تسجيل الدخول',
    _total_1_ryals: '1 SAR',
    _total_5_ryals: '5 SAR',
    _total_10_ryals: '10 SAR',
    _total_20_ryals: '20 SAR',
    _total_50_ryals: '50 SAR',
    _total_100_ryals: '100 SAR',
    _total_500_ryals: '500 SAR',
    open_shift: 'فتح الوردية',
    remainpso: 'المتوفر',
    current_qty: 'الكمية المتوفرة',
    total_income: 'اجمالي المبيعات',
    sales_qtty: 'الكمية المباعة',
    max_items_sales: 'الأكثر مبيعا',
    less_items_sates: 'الاصناف الراكدة',
    zero_items: 'الاصناف المنتهية',
    daily_report: 'تقرير اليومية',
    search_by_name: 'البحث بالاسم',
    today_date: 'تاريخ اليوم',
    fix_it: 'تثبيت',
    monthly_deduct: 'الخصم الشهري',
    deduct_amount: 'مبلغ الخصم',
    monthly_late: 'التأخير الشهري',
    deduct_type: 'نوع الخصم',
    minute_late: 'التاخير بالدقائق',
    deduct_resone: 'سبب الخصم',
    returned: 'المرتجع',
    part_amount: 'قيمة القسط',
    number_of_parts: 'عدد الاقساط',
    paid_in_advanced_total: 'اجمالي السلف',
    deduct: 'الخصومات',
    service: 'خدمات',
    mentanace_card: 'أوامر التشغيل',
    custdy: 'العهد',
    salary_total: 'اجمالي الراتب',
    lated_salaries: 'رواتب متأخرة',
    remain_salary: 'صافي الراتب',
    invoice_percentage: 'نسبة المبيعات',
    card_percentage: 'نسبة كروت الصيانة',
    posted_salary: 'الراتب المصدر',
    indemnity: 'مكافأة نهاية الخدمة',
    post_salary: 'اصدار راتب',
    add_reward: 'اضافة مكافأة',
    pay_advanced: 'اضافة سلفة',
    deduct_from_salary: 'خصم من الراتب',
    emp_statment: 'كشف حساب ',
    pay_from_cash: 'الدفع من الصندوق',
    pay_from_custdy: 'الدفع من العهدة',
    terms: 'الشروط والأحكام',
    vendor_payments: 'دفعات موردين',
    work_hours: 'ساعات العمل',
    back: 'رجوع',
    customer_sign: 'توقيع العميل',
    width: 'عرض',
    thickness: 'سماكة',
    limited: 'محدود',
    custody_statement: 'كشف عهد موظف',
    add_custody: 'اضافة عهدة',
    remain_custody: 'المتبقي من العهدة',
    return_custody: 'المدفوع من العهدة',
    custody: 'عهدة الموظف',
    full_cancel: 'الغاء كامل',
    partial_cancel: 'الغاء جزئي',
    full_cancel_reson: 'سبب الغاء كامل الطلب',
    cancel_reson: 'سبب الالغاء',
    cancel_qtty: 'الكمية الملغاه',
    order_items: 'اصناف الطلب',
    order_details: 'تفاصيل الطلب',
    order_time: 'وقت الطلب',
    order_date: 'تاريخ الطلب',
    orderid: 'رقم الطلب',
    view_order: 'عرض الطلب',
    add_order: 'اضافة طلب',
    cancel_order: 'الغاء الطلب',
    download: 'تحميل',
    file_name: 'اسم الملف',
    file_size: 'حجم الملف',
    client_statment: 'كشف حساب',
    salary_paid: 'سند صرف راتب',
    add_vendor_voucher: 'تسديد مورد',
    period_balance: 'رصيد المدة',
    credit_note: 'اشعار دائن',
    purchase_and_expenses: 'مشتريات ومصروفات',
    total_balance: "اجمالي الرصيد",
    previews_balance: "الرصيد السابق",
    today_balance: 'رصيد اليوم',
    daily_summary_for_date:'الملخص اليومي لتاريخ ',
    time: 'الوقت',
    payment_type: 'طريقة الدفع',
    amount: 'المبلغ',
    debet: 'مدين',
    details: 'التفاصيل',
    agree: 'موافق',
    row_type: 'نوع الاضافة',
    add_new_work_expenses: 'اضافة اصالاحات اخرى او قطع غيار',
    complete: 'انهاء',
    vin_numebr: 'رقم الهيكل',
    isbilled: 'الفوترة',
    approve_card: 'أمر التشغيل',
    chose_car_before_continue: 'يجب اختيار سيارة حتى تتم الاضافة',
    plase_select_car_scratch: 'يجب عليك ان ترسم على صورة السيارة اماكن الصدمات او الخدوش',
    you_must_add_atleast_one_work_item: 'يجب عليك اضافة وصف واحد على الاقل - او تأكد من انك ضغطت على زر اضافة بجانب الوصف بعد تعبئة البيانات والاسعار',
    you_must_add_one_car_atleast: 'يجب عليك اضافة سيارة على الاقل للمتابعة',
    car_information_must_be_complated: 'معلومات السيارة الموديل ونوع السيارة للوحة رقم  {{plate_number}} مطلوب للمتابعة',
    car_information_required: 'رقم اللوحة مطلوب للمتابعة',
    company_name_required: 'اسم الشركة مطلوب للمتابعة',
    customer_name_required: 'اسم العميل مطلوب للمتابعة',
    company_address_required: 'عنوان الشركة مطلوب للمتابعة',
    entity_name_required: 'اسم الجهة الحكومية مطلوب للمتابعة',
    chose_customer: 'اختار العميل',
    chose_company: 'اختر الشركة',
    chose_entity: 'اختر الجهة',
    reset: 'مسح',
    undo: 'تراجع',
    cars_status: 'حالة السيارات عند الاستلام',
    add_new_card: 'اضافة امر تشغيل',
    add_invocie: 'اضافة فاتورة',
    are_you_sure: 'هل أنت متاكد بانك تريد المتابعة',
    changeNote: 'اضافة الملاحظات',
    out_payments: 'سندات الصرف',
    in_payments: 'سندات القبض',
    cars_list: 'قائمة السيارات',
    total_discount: 'مبلغ الخصم',
    total_b_d: 'الاجمالي قبل الخصم',
    chose_car: 'اختار السيارة',
    expenses_invoices: 'فواتير المصروفات',
    bid_number: 'رقم المنافسة',
    view_quot_pdf: 'تحميل العرض',
    footer_extra: 'اضافات للفوتر',
    entity_name: 'اسم الجهة',
    branch_name: 'اسم الفرع',
    request_number: 'رقم الطلب',
    po_date: 'تاريخ المطالبة',
    new_customer: 'عميل جديد',
    add_invoice_notes: 'اضافة ملاحظات على الفاتورة (ضمان - اشتراطات - غيرها)',
    whatsapp: 'واتس اب',
    for_more_information_or_support_firstline: 'للدعم الفني الاتصال',
    for_more_information_or_support_secondline: '0565100268 - 0112297553 ',
    customer_company_info_required: 'عنوان واسم الشركة مطلوب',
    view_expenses: 'عرض فاتورة المصروفات',
    view_quotation: 'عرض السعر',
    expenses_type_reoprt: 'تقرير أنواع المصروفات',
    print_out_voucher: 'طباعة سند صرف',
    day: 'اليوم',
    this_item_service_item: 'لا يمكن اضافة الصنف الخدمي إلى فاتورة المشتريات',
    inventory_item: 'صنف مخزون',
    service_item: 'صنف خدمي',
    product_type: 'نوع الصنف',
    product_category: 'القسم',
    price_without_vat: 'السعر بدون ضريبة',
    price_inc_vat: 'السعر شامل الضريبة',
    default_cost: 'التكلفة الافتراضية',
    added_value_tax: 'تفعيل ضريبة القيمة المضافة',
    current_qtty: 'الكمية المتوفرة',
    add_edit_product: 'اضافة / تعديل منتج',
    // fftotal: 'الاجملاي',
    vat_summary: 'ملخص التقرير الضريبي',
    return_invoices: 'مرتجع الفواتير',
    view_page: 'معاينة الصفحة',
    government_clinet: ' حكومي',
    add_attachement: 'اضافة مرفقات',
    car_status_receive: 'حالة استلام السيارة',
    printing_header: 'هيدر الطباعة',
    invoice_body: 'صفحة الفاتورة',
    voucher_body: 'صفحة السند',
    card_body: 'صفحة كرت الصيانة',
    printing_footer: 'فوتر الطباعة',
    newpassword: 'كلمة المرور الجديدة',
    oldpassword: 'كلمة المرور القديمة',
    changePassword: 'تغيير كلمة المرور',
    fftotal: 'الاجمالي',
    total_without_vat: 'المجموع بدون ضريبة',
    chose_saler_name: 'اختر اسم البائع',
    chose_payment_method: 'اختر طريقة الدفع',
    chose_vat_type: 'اختر نوع الضريبة',
    chose_invoice_type: 'اختر نوع الفاتورة',
    chose_customer_type: 'اختر نوع العميل',
    print_in_voucher: 'طباعة سند قبض',
    save_n_print: 'حفظ وطباعة',
    car_ifnormation_required: 'بيانات السيارة مطلوبة رقم اللوحة، نوع السيارة و سنة الصنع',
    add_direct_invoice: 'اضافة فاتورة مباشرة',
    name_ar_en_required: 'نوع المصروف عربي انجليزي مطلوب دائما',
    add_expense_type: 'اضافة نوع مصروفات',
    invoice_export: 'اصدار فاتورة',
    sales_vat: 'ضريبة المبيعات',
    bill_vat: 'ضريبة المشتريات',
    print_voucher: 'طباعة ',
    purchase_summary: 'ملخص المشتريات',
    purchase_bill: 'فواتير المشتريات ',
    old_balance: 'رصيد سابق',
    expnese: 'المصروفات',
    other: 'اخرى',
    income_expense_report: 'تقرير الدخل اليومي',
    expenses_type_added: 'تم اضافة نوع المصروف بنجاح',
    add_new_expense_type: 'اضافة نوع مصروفات جديد',
    expenses_type_updated: 'تم تعديل نوع المصروف بنجاح',
    expense_namear: 'نوع المصروف عربي',
    expense_nameen: 'نوع المصروف انجليزي', 
    tafweed: 'التفويض',
    terms_of_use: 'شروط الاستخدام',
    logo_img: 'صورة الشعار',
    year: 'السنة',
    chose_month: ' الشهر',
    convert_to_invoice: 'تحويل لفاتورة',
    cards_expsenses: 'مصاريف الكروت',
    cards_number: 'عدد الكروت',
    catd_totals: 'اجمالي الكروت',
    totalPercent: 'النسبة المستحقة',
    percent_report: 'تقرير النسب',
    salary_report: 'تقرير الرواتب',
    sendWhats: '<i class="fa fa-whatsapp"></i>',
    total_invoices: 'اجمالي الفواتير',
    total_remain: 'اجمالي المتبقي',
    vin_number: 'رقم الهيكل',
    start_date: 'تاريخ البدء',
    end_date: 'تاريخ الانتهاء',
    worker_name: 'اسم الفني',
    work_price: 'وصف العمل',
    you_cannot_delete_this_item_paid_more_than_total: 'لا يمكنك حذف هذا العنصر وذلك لأن قيمة الدفعات اكبر من قيمة الكرت',
    company_name_en: 'Company English Name',
    contact_number: 'رقم الاتصال',
    booktime: 'وقت الطلب',
    orders: 'الطلبات',
    welcome: "مرحبا ",
    username: 'اسم المستخدم',
    item_cost: 'التكلفة',
    sent_requests: 'الارساليات',
    print_page: 'طباعة الصفحة',
    print_pagexport_pdfe: 'تصدير PDF',
    ment_req_cards_new: 'طلبات الصيانة الجديدة',
    ment_req_cards_late: 'طلبات الصيانة المتأخرة',
    ment_req_cards_closed: 'طلبات الصيانة المغلقة',
    payment_requests:'الدفعات',
    requests:'الارساليات',
    home: 'الرئيسية',
    additional_method: 'خصم اضافي غير خاضع للضريبة',
    adding_date: 'تاريخ الاضافة',
    ammount: 'القيمة',
    method: 'العملية',
    add_project: 'اضافة مشروع',
    projects: 'المبيعات',
    expeneses_type: 'نوع المصروفات',
    account_name: 'اسم الحساب',
    integrated_with_expenses: 'ربط المصروفات',
    account_integrated: 'الربط مع',
    default_type: 'قيمة الحساب',
    account_type: 'نوع الحساب',
    acount_name: 'اسم الحساب',
    update_acount: 'تحديث الحساب',
    accoutn_option: 'خيارات الحساب',
    mainaccount: 'الحساب الرئيسي',
    account_name_ar: 'الاسم العربي',
    account_name_en: 'الاسم الانجليزي',
    add_new_account: 'حساب جديد',
    view_employee: 'استعراض موظف',
    customer_addedd: 'تمت اضافة العميل بنجاح',
    please_choose_worker: 'يرجى اختيار منفذ العمل',
    job_price_required: 'يرجى اضافة سعر شغل اليد حتى تستطيع المتابعة',
    car_info_required: 'معلومات السيارة مطلوبة',
    delivery_date_required: 'تاريخ التسليم مطلوب',
    customer_info_required: 'رقم الاتصال يجب ان يبدأ بـ 05 واسم العميل مطلوب دائما',
    maintenance_cards: 'اوامر التشغيل',
    sales_crm: 'المبيعات',
    exp_management: 'مصروفات ادارية',
    bnl_report: 'قائمة الدخل',
    gozi_report: 'تقرير التأمينات',
    balance_report: 'الميزانية',
    addJV: 'اضافة قيد',
    notes: 'ملاحظات',
    jvnom: 'رقم القيد',
    vendor_name_required: 'اسم المورد مطلوب ويجب ان يكون اكبر من خمس احرف',
    finance_jvs: 'القيود',
    vendor_mobile_required: 'رقم اتصال المورد مطلوب ويجب ان يكون اكثر من خمس ارقام',
    vendor_updated_successufly: 'تمت اضافة / تعديل المورد بنجاح',
    update_vendor: 'تعديل مورد',
    add_vendor: 'اضافة مورد',
    invoice_total: 'اجمالي الفواتير',
    vat_total: 'قيمة الضريبة',
    price: 'السعر',
    late: 'متأخر',
    fixed_assets: 'الاصول الثابتة',
    class_name: 'اسم الحساب',
    add_pay_type: 'إضافة طريقة دفع',
    statment: 'كشف حساب',
    namear: 'الاسم العربي',
    nameen: 'الاسم الانجليزي',
    classid: 'رقم الحساب',
    amounttotal: 'اجمالي المبلغ',
    car_report: 'تقرير المركبة',
    definition: 'ربط الشجرة ',
    itotals_per_paymethod: 'اجمالي الدخل بحسب طريقة الدفع',
    ototals_per_paymethod: 'اجمالي المصروفات بحسب طريقة الدفع',
    account_statement: ' كشف حساب',
    account_balance_report: 'تقرير الموازنة',
    openingbalance: 'الرصيد الافتتاحي',
    transaction: 'رصيد العمليات',
    chart_of_account: 'شجرة الحسابات',
    paytypes: 'طرق الدفع',
    balance: 'الرصيد',
    accounts: 'الحسابات',
    incomes: 'الدخل',
    amountprice: 'المبلغ',
    account: 'الحساب',
    vlaue: 'القيمة',
    langname: 'ar',
    dir: 'rtl',
    ldir: 'ltr',
    algin: 'right',
    lalgin: 'left',
    invoiceno: 'رقم الفاتورة',
    plate_number: 'رقم اللوحة',
    main_menu: 'القائمة',
    search: 'بحث',
    invoices: 'الفواتير',
    add_invoice: 'اضافة فاتورة',
    invtype: 'نوع الفاتورة',
    customer: 'العميل',
    mobile: 'رقم الاتصال',
    plate: 'اللوحة',
    model: 'الموديل',
    inv_date: 'التاريخ',
    total: 'المجموع',
    vat: 'الضريبة',
    ftotal: 'الاجمالي مع الضريبة',
    paid: 'المدفوع',
    remain: 'المتبقي',
    remaremain_amountin: 'المبلغ المتبقي على العميل',
    action: 'الاجراء',
    status: 'الحالة',
    view: 'عرض',
    totals: 'المجموع',
    close: 'اغلاق',
    customer_name: 'اسم العميل',
    customer_type: 'نوع العميل',
    company_name: 'اسم الشركة / الجهة',
    comapny_address: 'عنوان الشركة',
    company_vatid: 'الرقم الضريبي',
    received_amount: 'المبلغ المدفوع',
    car_model: 'نوع المركبة',
    car_year: 'سنة الصنع',
    car_color: 'اللون',
    update_car: 'تعديل سيارة',
    invoice_type: 'نوع الفاتورة',
    vat_type: 'نوع الضريبة',
    payment_method: 'طريقة الدفع',
    saler_name: 'البائع',
    invoice_date: 'تاريخ الفاتورة',
    invoice_details: 'تفاصيل الفاتورة',
    item_code: 'رمز الصنف',
    description: 'الوصف',
    qtty: 'العدد',
    item_price: 'السعر',
    discount: 'الخصم',
    create_invoice: 'إنشاء فاتورة',
    cash_payment: 'الدفع نقدا',
    bank_payment: 'تحويل بنكي',
    span_payment: 'الدفعة بواسطة الشبكة',
    add: 'إضافة',
    individual_client: ' فردي',
    company_clinet: ' شركة',
    prices_include_vat: 'السعر شامل الضريبة',
    prices_exclusive_vat: 'السعر غير شامل الضريبة',
    prices_without_vat: 'بدون ضريبة',
    none_paid_invoice: 'فاتورة آجلة',
    paid_invoice: 'فاتورة نقدية', 
    multi_payments: 'الدفع المتعدد',
    required_field: 'الحقل مطلوب',
    view_purchase_bill: 'عرض فاتورة مشتريات',
    view_purchase_return: 'عرض مرتجع فاتورة مشتريات',
    you_can_not_add_empty_invoice: 'لا يمكن اضافة فاتورة فارغة',
    company_ifnormation_required: 'يرجى ادخال بيانات الشركة اسم الشركة، رقم السجل، العنوان',
    invoice_added: 'تمت اضافة الفاتورة بنجاح',
    can_not_add_item_withoud_discription: 'لا يمكن اضافة صنف بدون وصف',
    item_qtty_must_be_more_than_zero: 'لا يمكن اضافة صنف بدون كمية',
    item_price_must_be_more_than_zero: 'لا يمكن اضافة صنف بدون سعر',
    view_pdf: 'تحميل الفاتورة',
    invoice_return: 'ارجاع الفاتورة',
    make_payment: 'سداد دفعة',
    invoice_tme: 'وقت الفاتورة',
    return_time: 'وقت الارجاع',  
    return_case: 'سبب الارجاع',
    total_exclusive_vat: 'اجمالي بدون ضريبة',
    total_include_vat: 'اجمالي مع ضريبة',
    payments: 'الدفعات',
    payment_date: 'تاريخ الدفعة',
    payment_time: 'توقيت الدفعة',
    payment_amount: 'قيمة الدفعة ',
    payment_cash: 'نقدا',
    payment_span: 'شبكة',
    payment_bank: 'تحويل',
    return_invoice: 'ارجاع فاتورة',
    return_amount: 'المبلغ المرتجع',
    return: 'ارجاع',
    maint_return: 'اعادة صيانة',
    system_modules: 'اقسام النظام',
    customers: 'العملاء',
    accounting: 'المحاسبة',
    envintory: 'المخزون',
    reports: 'التقارير',
    settings: 'الاعدادات',
    logout: 'تسجيل الخروج',
    invoice_notes: 'ملاحظات الفاتورة',
    additional_mobile: 'الرقم الاضافي',
    client_statement: 'كشف حساب',
    mobil_10_digits: 'رقم الجوال يجب ان يكون عشرة ارقام',
    customer_added: 'تمت اضافة العميل بنجاح',
    add_quotation: 'اضافة عرض ',
    quotnumber: 'رقم العرض',
    salesman: 'البائع',
    quot_date: 'تاريخ العرض',
    quotation_details: 'تفاصيل العرض',
    delete: 'حذف',
    company_client: 'عميل شركة',
    can_not_add_empty_row: 'لا يمكن اضافة صنف فارغ',
    please_add_company_info: 'يرجى اضافة بيانات الشركة',
    quotation_added: 'تمت اضافة العرض بنجاح',
    can_not_add_row_without_discription: 'لا يمكن اضافة صنف بدون وصف',
    can_not_add_row_with_qtty: 'جيب ان تكون الكمية اكبر من 0',
    date: 'التاريخ',
    credit: 'دائن',
    new_quotations: 'العروض الجديدة',
    invoiced_quots: 'العروض المفوترة',
    canceled_quots: 'العروض الملغية',
    quotation_no: 'رقم العرض',
    printQuot: 'طباعة العرض',
    cancel_quto: 'الغاء العرض',
    quot_time: 'توقيت العرض',
    print: 'طباعة',
    cash_total: 'المجموع النقدي',
    span_total: 'بطاقات البنك',
    voutcher_no: 'رقم السند',
    receive_from: 'استلام من',
    receive_by: 'الاستلام بواسطة',
    cash: 'نقدا',
    received_voucher: 'سندات القبض',
    exchange_voucher: 'سندات الصرف',
    employees: 'الموظفين',
    recurring_expensess: 'مصاريف دورية',
    add_voutchre: 'اضافة سند',
    voutcher_resone: 'سبب السند',
    emp_name: 'اسم الموظف',
    id_number: 'رقم الهوية',
    basic_salary: 'الراتب الاساسي',
    home_allownance: 'بدل السكن',
    trans_allownance: 'بدل النقل',
    food_allown: 'بدل الطعام',
    other_allown: 'بدلات اخرى',
    goze_perc: 'التأمينات',
    percentate: 'النسبة',
    update: 'تعديل',
    add_employee: 'اضافة موظف',
    add_expenses: 'اضافة مصروفات',
    expense_type: 'نوع المصروف',
    yearly: 'سنوي',
    midterm: 'نصف سنوي',
    quarterly: 'ربع سنوي',
    monthly: 'شهري',
    daily: 'يومي',
    expense_total: 'اجمالي المصروف',
    expense_period: 'مدة المصروف',
    calculation_will_be_done_automatic: 'Calculation values will be done automaticlly',
    office_rent: 'اجار المكتب',
    add_maint_request: 'اضافة امر تشغيل ',
    cardid: 'رقم البطاقة',
    delivered: 'التسليم',
    spare_partes: 'قطع الغيار',
    spare_parts: 'قطع الغيار',
    main_info: 'معلومات اساسية',
    delivery_date: 'تاريخ التسليم',
    company_info: 'معلومات الشركة',
    car_info: 'معلومات السيارة',
    received_status: 'حالة استلام السيارة كتابيا',
    work_description: 'وصف العمل',
    worker: "العمالة",
    advanced_payment: 'دفعة مقدمة',
    attachement: 'المرفقات',
    send_job_card_to_customer: 'ارسال امر التشغيل للعميل',
    send_selected_to_customer: 'ارسال المحدد للعميل',
    issue_draft_invoice: 'اصدار مسودة',
    request_spare_parts: 'طلب قطع غيار',
    request_spare_parts_items: 'طلب عناصر قطع الغيار',
    add_labor_work: 'اضافة شغل يد',
    add_spare_parts_unbilled: 'اضافة قطع غيار غير مفوتر',
    add_spare_parts_billed: 'اضافة قطع غيار مفوتر',
    spare_parts_requests: 'طلبات قطع الغيار',
    purchase_requests: 'طلبات الشراء',
    done: 'مكتمل',
    not_done: 'غير مكتمل',
    decline: 'رفض',
    confirm_decline_spare_request: 'هل أنت متأكد أنك تريد رفض طلب قطع الغيار؟',
    confirm_approve_spare_request: 'هل أنت متأكد أنك تريد اعتماد طلب قطع الغيار؟',
    confirm_create_purchase_bill: "هل تريد تسجيل القطعة كمطلوبة؟ هذا الإجراء لا ينشئ فاتورة شراء.",
    final_invoice_required_before_close: 'يجب اصدار فاتورة نهائية قبل اغلاق المسار',
    confirm_return_item: 'هل انت متاكد بانك تريد ارجاع هذا العنصر',
    send_success: 'تم الارسال بنجاح',
    job_card_sent_to_customer: 'تم ارسال الكرت الى العميل',
    path_info_title: 'معلومات المسار',
    choose_file: 'اختر الملف',
    save: 'حفظ',
    additional_information: 'بيانات اضافية',
    work_description_required: 'وصف العمل مطلوب',
    added_sucess: 'تمت الاضافة بنجاح',
    add_user: 'إضافة مستخدم',
    update_user: 'تعديل مستخدم',
    users: 'المستخدمين',
    user_name: 'اسم الموظف',
    login_name: 'اسم الدخول',
    permission: 'الصلاحية',
    last_login: 'آخر دخول',
    save_login_info: 'حفظ بيانات الدخول',
    password: 'كلمة المرور',
    export_excel: 'تصدير اكسل',
    add_purcahse: 'اضافة مشتريات',
    vendor: 'المورد',
    vendors: 'الموردين',
    purchase: 'المشتريات',
    purchase_order: 'أمر شراء',
    purchase_return: 'مرتجع المشتريات',
    purchase_report: 'تقرير المشتريات',
    inventory: 'المخزون',
    item_name: 'اسم الصنف',
    sales_invoices: 'فواتير المبيعات',
    sales: 'المبيعات',
    vat_required_return: 'قيمة الضريبة المضافة المستحقة (المستردة)',
    vat_report: 'تقرير الضريبة',
    dealy_report: 'تقرير اليومية',
    card_report: 'تقرير البطاقات',
    sales_report: 'تقرير المبيعات',
    return_report: 'تقرير المرتجع',
    percentage_report: 'تقرير النسب',
    percentage: 'النسبة',
    income: 'الدخل',
    expense: 'المصروف',
    period_expenses: 'المصاريف الدورية',
    return_by: 'مرتجع عن طريق',
    shortcust_name: 'الاسم المختصر',
    vat_number: 'الرقم الضريبي',
    system_settings: 'اعدادات النظام',
    welcometo: 'مرحبا ',
    added_date: 'تاريخ الاضافة',
    added_time: 'التوقيت',
    photo_gallary: 'معرض الصور',
    print_card: 'طباعة البطاقة',
    car_description: 'وصف السيارة',
    invoice_samary: 'ملخص البطاقة',
    others: 'أخرى',
    view_card: 'استعراض البطاقة',
    card_closed: 'تم اغلاق البطاقة',
    please_check_data: 'يرجى التحقق من البيانات',
    cant_close_card_when_it_not_fully_paid: 'يجب استكمال الدفعات قبل اغلاق البطاقة',
    card_saved: 'تم حفظ البطاقة',
    customerid: 'المعرف',
    purchase_invoice: 'فاتورة مشتريات',
    billno: 'رقم الفاتورة',
    vendor_name: 'اسم المورد',
    vendor_mobile: 'رقم الهاتف - الجوال',
    vendor_vatids: 'الرقم الضريبي للمورد',
    vendor_address: 'عنوان المورد',
    type: 'النوع',
    bill_type: 'نوع الفاتورة',
    bill_detates: 'تفاصيل الفاتورة',
    item_unit: 'الوحدة',
    pace: 'حبه',
    close_card: 'اغلاق البطاقة',
    chose_file: 'اختر الملف',
    upload: 'تحميل',
    full_name: 'الاسم كاملا',
    total_amount: 'اجمالي المبلغ',
    buy_goods: 'شراء بضاعة',
    sallary: 'راتب',
    buy_devices: 'شراء اجهزة',
    pay_for_bills: 'دفع فواتير',
    added_successfuly: 'تمت الاضافة بنجاح',
    nationality: 'الجنسية',
    percent: 'النسبة',
    group_name: 'اسم المجموعة',
    permissions: 'الصلاحيات',
    administratior: 'الادارة العامة',
    full_permissions: 'صلاحيات كاملة',
    accountant: 'المحاسبة',
    accountatn_permissions: 'كل الصلاحيات بدون الاعدادات',
    cashier: 'الكاشير',
    cashier_permissions: 'الفواتير والبطاقات',
    choose_employee: 'اختر الموظف',
    employees_and_users: 'الموظفين',
    salary_table: 'مسير الرواتب',
    projectname: 'اسم المشروع',
    inprogress: 'تحت العمل',
    new: 'جديد',
    closed: 'مغلق',
    not_invoiced: 'غير مفوتر',
    added_by: 'بواسطة',
    vendorid: 'معرف المورد',
    paid_in_advanced: 'السلف',
    paid_in_advanced_amount: 'قيمة السلفة',
    installment_number: 'عدد الدفعات',
    installment_amount: 'قيمةالدفعة',
    mor_than_zero: 'يرجى اضافة رقم اكبر من الصفر',
    emp_reward: 'المكافآت',
    emp_deducts: 'الخصومات',
    reward_amount: 'قيمة المكافأة',
    reward_resone: 'سبب المكافأة',
    deducts_amount: 'قيمة الخصم',
    deducts_resone: 'سبب الخصم',
    penalty_amount: 'قيمة الخصم',
    penalty_reason: 'سبب الخصم',
    penalty_reason_required: 'سبب الخصم مطلوب',
    canceled: 'ملغي ',
    notpaid: 'لم يتم السداد',
    emp_custody: 'العهد',
    custody_amount: 'مبلغ العهدة',
    workstartdate: 'تاريخ بدء العمل',
    fix_salary: 'اصدار الراتب',
    card_expenses: 'مصروفات الصيانة من المخزون',
    invoice_expenses: 'مصاريف الفاتورة',
    expenses_summary: 'ملخص المصاريف',
    general_expenses: 'مصاريف عامة',
    cards_expenses: 'الصيانة',
    invoices_expenses: 'الفواتير',
    salaries: 'الرواتب',
    add_general_expense: ' مصروفات ',
    periodically: 'دورية',
    payit: 'سداد',
    pay_expenses: 'تسديد المصاريف',
    payment_period: 'مدة السداد',
    expense_amount: 'المبلغ',
    othermethod: "طرق دفع ", 
    invoices_total: 'اجمالي الفواتير', 
    invoices_remain: 'متبقي الفواتير', 
    other_expenses: 'مصاريف اخرى', 
    exp_total: 'اجمالي المصروفات', 
    exp_vat:'ضريبة المصروفات',
    building_no: 'رقم المبنى',
    street_name: 'اسم الشارع',
    branch_number: 'الرقم الفرعي',
    district: 'الحي',
    zipcode: 'الرمز البريدي',
    city:'المدينة',
    address: 'العنوان',
    update_customer: 'تعديل عميل',
    customer_updated: 'تم تعديل العميل',
    update_all: 'تعديل الكل',
    update_all_notes: 'تعديل الكل : تعديل كل الفواتير او سندات القبض بالبيانات الجديدة',
    curency: 'ريال',
    pos: 'نقطة بيع',
    total_after_discount: 'اجمالي بعد الخصم',
    total_after_discountt: 'السعر بعد الخصم',
    multi_payment: 'الدفع المتعدد',
    paid_amount: 'المبلغ المدفوع',
    product_categories: 'أقسام المخزون',
    category_name: 'القسم',
    category_name_ar: 'اسم القسم عربي',
    category_name_en: 'اسم القسم انجليزي',
    category_type: 'نوع القسم',
    category_parent: 'القسم الرئيسي',
    subcat_count: 'الاقسام الفرعية',
    add_category: 'اضافة قسم',
    main_cat: 'قسم رئيسي',
    sub_cat: 'قسم فرعي',
    income_report: 'تقرير الدخل',
    maint_start_date: 'تاريخ بداية الصيانة',
    maint_end_date: 'تاريخ انتهاء الصيانة',
    policy_number: 'رقم وثيقة التأمين',
    engine_meter: 'عداد السيارة (كم)',
    next_oil_change: 'تغيير الزيت بعد (كم)',
    crt_number: 'السجل التجاري',
    cashflow: 'حركة النقد',
    process_job_list: 'اوامر تشغيل تحت الاجراء',
    closed_job_list: "أوامر تشغيل مغلقة",
    not_invoice_job_list: "أوامر تشغيل غير مفوتر",
    invoiced_job_list: "أوامر تشغيل مفوتر",
    current_paid_job_list: "أوامر تشغيل قيد التحصيل",
    choose_mentainance_date: 'اختر تاريخ الصيانة',
    mentainance_time: 'وقت الصيانة',
    offers_programs: 'البرامج التسويقية',
    program_name: 'اسم البرنامج',
    booking_date: 'تاريخ الموعد',
    booking_time: 'وقت الموعد',
    contract_details: 'تفاصيل العقد',
    print_job_order: 'طباعة امر العمل',
    work_total_price: "صافي شغل اليد",
    other_profit_total: 'صافي الارباح الاخرى',
    all_: 'الكل',
    chose_store: 'اختر المستودع',
    cost_center_name_ar: 'مركز التكلفة - عربي',
    cost_center_name_en: 'مركز التكلفة - انجليزي',
    costCenter: 'مركز التكلفة',
    addCostCenter: 'اضافة مركز تكلفة',
    without_cost_center: 'بدون مركز تكلفة',
    account_client_type: 'نوع حساب العميل',
    customer_client: 'حساب عميل',
    customer_group_client: 'حساب قسم رئيسي',
    main_clients: 'الحساب الرئيسي',
    without_account: 'بدون حساب رئيسي',
    depreciation_account: 'حساب الاهلاك',
    quarter: 'ربع سنوي',
    semiannually: 'نصف سنوي',
    annually: 'سنوي',
    delivery_note: 'سند استلام',
    consumption_rate: 'الخصم بـ',
    consumption_fees: 'رسوم استهلاك',
    consumption_value: 'رسوم استهلاك',
    add_check: 'استلام سيارة',
    checkup_type: 'نوع الفحص',
    checkup_number: 'رقم الفحص',
    contract_number: 'رقم العقد',
    insurance_company: 'شركة التأمين',
    delivered_by: 'التسليم بواسطة',
    car_received_status: 'حالة السيارة عند الاستلام',
    maintenance_required: 'الاصلاحات المطلوبة',
    direction: 'الاتجاه',
    description_required: 'الوصف مطلوب ولا يمكن ان يكون فارغا',
    insurance_company_required: 'يجب اضافة شركة التأمين',
    customer_required: 'يجب ان تقوم باضافة عميل',
    car_model_required: 'يجب اضافة نوع السيارة',
    car_brand_required: 'يجب اضافة الشركة الصانعة للسيارة',
    made_year_required : 'يجب اضافة تاريخ صنع السيارة',
    car_color_required: 'لون السيارة مطلوب',
    please_add_one_car_received_status: 'يجب اضافة حالة واحده للسيارة على الاقل',
    please_add_one_car_maintenance: 'يجب اضافة طلب اصلاح واحد على الاقل',
    checkup_id: 'معرف الاستلام',
    owner_mobile_number: 'رقم اتصال المالك',
    discountType: 'نوع الخصم',
    report_day: 'اختر اليوم',
    exit_time: 'وقت انتهاء الوردية',
    chose_user: 'اختر المستخدم',
    report_type: 'نوع التقرير',
    printer_type: 'نوع الطباعة',
    car_location: 'موقع السيارة',
    transportant_info: 'بيانات الناقل',
    transportant_name: 'اسم الناقل',
    transport_direction: 'جهة القدوم',
    driver_name: 'اسم السائق',
    driver_mobile: 'رقم السائق',
    trnasport_type: 'نوع النقل',
    store: 'اسم رقم المستودع',
    special_return: 'مرتجع خاص',
    return_total_price: 'اجمالي المبلغ المرتجع',
    print_return: 'طباعة المرتجع',
    viewr_pdf: 'تحميل PDF',
    balances: 'الأرصدة',
    def_descriptions: 'الوصف الافتراضي',
    internal_code: 'الترقيم الداخلي',
    can_be_returned: 'يمكن ارجاعه',
    prices_and_costs: 'الاسعار والتكلفة',
    default_price: 'السعر الافتراضي',
    default_discount: 'الخصم الافتراضي',
    min_price: 'اقل سعر',
    max_price: 'أعلى سعر',
    this_product_already_exist: 'هذا المنتج موجود مسبقا',
    copy: 'نسخ',
    contract_items: 'اصناف العقد',
    invocies: 'الفواتير',
    national_address_required: 'تفاصيل العنوان الوطني مطلوبة دائما',
    crt_number_required: 'رقم السجل للشركة او المؤسسة مطلوب دائما',
    fill_all_fields: 'يرجى تعبئة جميع الحقول',
    client_email: 'البريد الالكتروني',
    client_activity: 'نشاط العميل',
    client_sub_activity: 'النشاط الفرعي',
    container_number: 'عدد الحاويات',
    container_type: 'نوع الحاويات',
    country_of_origin: 'بلد المنشأ',
    port_of_arrival: 'ميناء القدوم',
    port_of_destination: 'ميناء الوصول',
    type_of_payments: 'طريقة السداد',
    nature_of_nuloading: 'طبيعة التحميل',
    deal_info: 'معلومات الصفقة',
    response_name: 'اسم المسؤول',
    response_mobile: 'جوال المسؤول',
    response_email: 'ايميل المسؤول',
    type_of_cargo: 'نوع الشحن',
    port_of_cargo: 'ميناء الشحن',
    supplier_address: 'عنوان المورد',
    number_of_container_monthly: 'عدد الحاويات الشهري',
    number_of_container_by_policy: 'عدد الحاويات حسب البوليصه',
    container_weight: 'وزن الحاوية مع البضاعه',
    transport_destinations: 'وجهات النقل',
    search_all: 'البحث بالكل',
    identified: 'المعرف',
    day_report: 'تقرير اليوم',
    span: 'شبكة',
    income_total: 'اجمال الايرادات',
    epxpense_total: 'اجمالي المصروفات',
    employee_id: 'رقم الموظف',
    received: 'تم الاستلام',
    card_number: 'عدد البطاقات',
    service_total: 'قيمة شغل اليد',
    precentage_total: 'مبلغ النسبة',
    request_payment: 'طلب دفعة',
    customer_remain_total: 'المبلغ المتبقي على العميل',
    checkup_notes: "ملاحظة: الكراج غير مسؤول عن الاغراض الشخصية بداخل السيارة",
    employee_type: 'نوع الموظف',
    background: 'الخلفية',
    font_color: 'لون الخط',
    chose_technical_or_more: "اختر فني او اكثر",
    returned_amount: 'المبلغ المرتجع',
    view_invoice: 'استعراض فاتورة',
    this_is_returend_invoice: "هذه الفاتورة مرتجعة",
    canceled_by: 'تم الغاء هذه البطاقة بواسطة',
    issue_date: 'بتاريخ',
    cancel_resone: "وسبب الالغاء",
    change_oil_after: 'تغيير الزيت بعد',
    cancel_post: 'الغاء ترحيل',
    repost: 'ترحيل',
    post_purchase_note: "إلغاء الترحيل يعيد الفاتورة إلى المسودة ويعكس المخزون والقيد المحاسبي والسداد المرتبط بها. هل تريد المتابعة؟",
    path_number: 'رقم المسار',
    vin_number_required: 'رقم الهيكل مطلوب دائما',
    sign_quotation: 'توقيع العميل',
    you_can_not_add_empty_custody: 'لا يمكن اضافة عهدة فارغة',
    added_successfully: 'تمت الاضافة بنجاح',
    zatca_not_integrated_message: 'انت لا تستخدم مرحلة الربط والتكامل مع هيئة الزكاه والضريبة والجمارك لإتمام عملية الربط يجب تعبئة النموذج التالي',
    zatca_integrated_message: 'أنت الان تستخدم مرحلة الربط والتكامل مع هيئة الزكاه - جميع الفواتير ترسل إلى هيئة الزكاه والضريبة',
    en_company_name: 'الشركة/ المؤسسة بالانجلييز',
    en_address: 'العنوان بالانجليزي',
    ar_address: 'العنوان بالعربي',
    integration_type: 'نوع الربط',
    active_zatca: 'تفعيل الربط',
    national_address: 'العنوان الوطني',
    add_starter_inventory: 'الرصيد الافتتاحي',
    postInv: 'ترحيل المخزون',
    store_settlement: 'تسوية مخزن',
    company_vatid_required: 'الرقم الضريبي يجب أن يكون دائما 15 عشرا رقم او 10 ارقام أو سيتم تجاهل الرقم الضريبي واعتبار الفاتورة فاتورة ضريبية مبسطة',
    building_no_required: 'في الفاتورة الضريبية .. رقم المبنى يجب ان يكون رقما من اربع خانات او سيتم اعتبار الفاتورة فاتورة ضريبية مبسطة',
    street_name_required: 'اسم الشارع مطلوب دائما في الفواتير الضريبية',
    branch_number_required: 'الرقم الفرعي مطلوب دائما في الفواتير الضريبية ويجب ان يكون مؤلفا من اربع ارقام او سيتم اعتبار الفاتورة فاتورة ضريبية مبسطة',
    district_required: 'الحي مطلوب دائما في الفواتير الضريبية',
    zipcode_required: 'الرمز البريدي مطلوب دائما في الفواتير الضريبية ويجب ان يكون مؤلفا من خمسة ارقام او سيتم اعتبار الفاتورة فاتورة ضريبية مبسطة',
    city_required: 'المدينة مطلوبة دائما في الفواتير الضريبية',
    service_work_item: 'الاصناف الخدمية',
    items_for_customer_approval: 'اصناف لموافقة العميل',
    spare_part_included_in_invoice: 'قطع غيار تظهر بالفاتورة',
    spare_part_not_included_in_invoice: 'قطع غيار لا تظهر بالفاتورة',
    part_type: 'نوع المخزون',
    from_inventory: 'من المخزون',
    from_out_of_store: 'من الخارج',
    add_sparepart: 'اضافة قطع غيار',
    spare_parts_receipt: 'سند قبض',
    invoiced: 'مفوتر',
    add_to_invoice: 'اضافة للفاتورة',
    need_approval: 'يحتاج للموافقة',
    approved: 'تمت الموافقة',
    approved_type: 'نوع التعميد',
    add_service: 'اضافة شغل يد',
    account_level: 'مستوى الحساب',
    per_discount: 'نسبة الخصم',
    history_type: 'نوع المستند',
    history_id: 'رقم المستند',
    update_cardInfo: 'تعديل كرت',
    print_jentry: 'طباعة القيد',
    customer_information: 'بيانات العميل',
    number_of_services: 'عدد الخدمات',
    deal_status: 'حالة الصفقة',
    contacts_information: 'بيانات التواصل',
    attached_files: 'المرفقات',
    add_cargo: 'اضافة شحن',
    add_customs: 'اضافة تخليص',
    add_transport: 'اضافة نقل',
    add_attachment: 'اضافة مرفق',
    are_you_sure_delete: 'هل أنت متاكد بانك تريد حذف {name}',
    response_person_deleted: 'تم حذف جهة الاتصال {name} بنجاح',
    chose_contact_for_print: 'اختر للطباعة',
    view_notes: 'الملاحظات',
    country_code: 'رمز الدولة (حرفين باللغة الانجليزية)',
    ar_company_name: ' الشركة/المؤسسة بالعربي',
    street_name_ar: ' الشارع عربي',
    street_name_en: ' الشارع انجليزي',
    district_ar: 'الحي عربي',
    district_en: 'الحي انجليزي',
    city_en: 'المدينة انجليزي',
    city_ar: 'المدينة عربي',
    zatca_integrated_worning: 'انت الان تقوم بالربط مع الزكاه - هل أنت متأكد بانك تريد المتابعة',
    you_will_save_information_without_any_creating_action: 'سيتم حفظ البيانات بدون اي تاثير - حتى تقوم بتغيير الحالة إلى مفعل',
    all_fields_required: 'جميع الحقول مطلوبة',
    vat_number_required: 'الرقم الضريبي مطلوب دائما ويجب أن يكون عشرة ارقام او 15 رقما',
    crt_number_requirs: 'رقم السجل مطلوب ويجب ان يكون رقما من عشرة خانات',
    vat_number_start_with_3: 'يجب أن يبدأ الرقم الضريبي برقم 3 فقط',
    vat_number_end_with_3: 'يجب أن ينتهي الرقم الضريبي برقم 3 فقط',
    branch_number_requirs: 'الرقم الفرعي يجب ان يكون رقما من اربع خانات',
    building_no_requirs: 'رقم المبنى يجب ان يكون رقما من اربع خانات',
    ziocide_requirs: 'الرمز البريدي يجب ان يكون رقما من خمسة خانات',
    you_will_create_private_and_public_keys_only: 'سيتم انشاء شهادة فقط هل انت متاكد من انك تريد المتابعة',
    you_will_create_simultation_certificat: 'سيتم الربط مع الزكاه - في البيئة التجريبية هل أنت متاكد بانك ترغب بالمتابعه',
    you_will_create_production_certificat: 'سيتم الربط مع الزكاه - للمرحلة الثانية هل أنت متاكد بانك ترغب بالمتابعه',
    continue: 'المتابعة',
    address_ar_requirs: 'العنوان بالعربي يجب أن لا يتجاوز 100 حرف',
    address_en_requirs: 'العنوان بالانجليزي يجب أن لا يتجاوز 100 حرف وان يكون حروف وارقام انجليزيه فقط',
    otp_number: 'OTP Number',
    opt_number_description: '- OTP Number : كلمة مرور لمرة واحده يتم الحصول عليها من منصة فاتورة في موقع الزكاه',
    compnay_name_en_requirs: 'اسم الشركة باللغة الانجليزية يجب أن يكون احرف انجليزية وارقام فقط',
    updated_successfully: 'تم التحديث بنجاح',
    updated_successfully_zatca: 'تم التحديث بنجاح وسيتم انشاء الشهادة او الربط خلال الساعات المقبله',
    otp_number_required: 'كلمة المرور لمرة واحده مطلوبة ويجب ان تتالف من ستة ارقام',
    contact_person: 'اسم جهة التواصل',
    contact_person_mobile: 'رقم جهة التواصل',
    who_will_contact: 'جهة التواصل الاساسية',
    main_number: 'الرقم الاساسي',
    jvtype: 'نوع القيد',
    jv_purchase: 'فاتورة مشتريات',
    jv_vendors: 'سداد مورد',
    return_payment_from_vendor: "استرجاع دفعة",
    general_payment: 'طريقة دفع عادية',
    balanced_payments: 'مطلوب موازنه',
    classid_balanced: 'حساب الموازنة',
    class_name_balanced: 'اسم حساب الموازنة',
    post_balance: 'ترحيل الرصيد',
    add_return: 'اضافة مرتجع',
    return_qty: 'الكمية المرتجعه',
    allowed_qty: 'المسموح ارجاعه',
    vendor_category: 'تصنيف المورد',
    only_vendor: 'مورد فقط',
    vendor_and_customer: 'عميل مورد',
    main_print_settings: "الأقسام الرئيسية",
    invoice_print_settings: "طباعة الفاتورة",
    quotation_print_settings: "طباعة عرض السعر",
    job_card_print_settings: "طباعة أمر التشغيل",
    add_new_row: "اضافة صفوف جديدة",
    delete_old: "حذف السابق والبدء من جديد",
    purchase_accounts: 'حساب المشتريات',
    messages: 'مراسلة',
    sparepart_required: "قطع الغيار المطلوبة",
    edit_qty: "تعديل الكمية",
    edit_price: "تعديل السعر",
    zatca_create_cert_only: 'انشاء شهادة فقط',
    zatca_sandbox_integration: 'الربط التجريبي',
    zatca_production_integration: 'الربط النهائي',
    zatca_not_active: 'غير مفعل',
    zatca_enable_integration: 'تفعيل الربط',
    add_work_type: 'اضافة نوع العمل',
    work_orders_count: 'عدد اوامر العمل',
    cars_count: 'عدد السيارات',
    operation_number: 'رقم التشغيل',
    car: 'السيارة',
    operation_date: 'تاريخ التشغيل',
    expected_hours: 'ساعات متوقعه',
    operation_hours: 'ساعات التشغيل',
    sold_hours: 'ساعات مباعة',
    sold_value: 'قيمة المباع',
    start_date_before_end_date: 'يجب ان يكون تاريخ البدء اقل من او يساوي تاريخ الانتهاء',
    search_in_table: 'بحث داخل الجدول',
    whats_campaign: 'حملة الواتس',
    whats_campaign_with_device: 'حملة برنامج مع جهاز',
    jeddah: 'جدة',
    sent_time: 'وقت الارسال',
    sent_to: 'تم إرسال إلى',
    read_messages: 'الرسائل المقروءة',
    contacted_customers: 'عملاء تم التواصل',
    purchased: 'تم الشراء',
    top_selling_cities: 'أكثر المدن مبيعا',
    top_responsive_cities: 'أكثر المدن استجابة',
    connected: 'متصل',
    yes: 'نعم',
    saturday: 'السبت',
    sunday: 'الأحد',
    monday: 'الاثنين',
    tuesday: 'الثلاثاء',
    wednesday: 'الاربعاء',
    thursday: 'الخميس',
    friday: 'الجمعة',
    technical_support: 'دعم فني',
    mobile_number: 'رقم الجوال',
    company_or_institution: 'الشركة/المؤسسة',
    commercial_register: 'السجل التجاري',
    tax_number: 'الرقم الضريبي',
    device_insurance: 'تأمين أجهزة',
    points_count: 'عدد النقاط',
    by: 'بواسطة',
    installation_delivery_terms: 'شروط واحكام التركيب والتوصيل',
    customer_requirements: 'متطلبات يجب توفيرها من قبل العميل',
    maintenance_request_description: 'وصف طلب الصيانة',
    installment: 'الدفعة',
    note: 'الملاحظة',
    whatsapp_message: 'رسالة الواتس اب',
    maintenance_requests: 'طلبات الصيانة',
    view_maintenance_request: 'استعراض طلب صيانة',
    select_items_to_return: 'يرجى اختيار عنصر أو اكثر من الفاتورة ليتم ارجاعها',
    item_type: 'نوع الصنف',
    confirm_delete_vendor: 'هل انت متاكد بانك تريد حذف المورد',
    vendor_item_saved_successfully: 'تم اضافة / تعديل الصنف بنجاح',
    status_under_review: 'تحت المراجعة',
    status_received: 'تم الاستلام',
    status_canceled: 'ملغي',
    status_partial_received: 'استلام جزئي',
    status_new_request: 'طلب جديد',
    status_paid: 'تم السداد',
    status_in_progress: 'تحت الاجراء',
    salary_deduction: 'خصم من الراتب',
    add_advance: 'اضافة سلفة',
    add_bonus: 'اضافة مكافأة',
    issue_salary: 'اصدار الراتب',
    work_start_date: 'تاريخ بدء العمل',
    end_of_service_bonus: 'مكافئة نهاية الخدمة',
    salary_source: 'الراتب المصدر',
    total_salary: 'اجمالي الراتب',
    discounts: 'الخصومات',
    advances: 'السلف',
    bonuses: 'المكافآت',
    maintenance_cards_percentage: 'نسبة كروت الصيانة',
    sales_percentage: 'نسبة المبيعات',
    net_salary: 'صافي الراتب',
    housing_allowance: 'بدل السكن',
    transport_allowance: 'بدل النقل',
    food_allowance: 'بدل الطعام',
    other_allowances: 'بدلات اخرى',
    card_date: 'تاريخ البطاقة',
    car_type: 'نوع السيارة',
    total_services: 'اجمالي الخدمات',
    work_percentage: 'نسبة العمل',
    invoice_sales: 'مبيعات الفواتير',
    advance_date: 'تاريخ السلفة',
    advance_amount: 'قيمة السلفة',
    installment_count: 'عدد الاقساط',
    remaining_amount: 'المتبقي',
    bonus_date: 'تاريخ المكافئة',
    bonus_amount: 'قيمة المكافئة',
    bonus_reason: 'سبب المكافئة',
    discount_date: 'تاريخ الخصم',
    discount_amount: 'قيمة الخصم',
    discount_reason: 'سبب الخصم',
    custodies: 'العهد',
    custody_date: 'تاريخ التسليم',
    currency: 'ريال',
    general_center: 'المركز العام',
    german_section: 'القسم الالماني',
    branch: 'الفرع',
    income_center: 'مركز الدخل',
    cashier_employee: 'موظف كاشير',
    general_management: 'ادارة عامة',
    suppliers: 'الموردين',
    permissions_group: 'مجموعة الصلاحيات',
    permissions_group_note: 'اذا لم تقم باختيار المجموعة ستبقى الصلاحيات الحالية كما هي',
    settings_saved_tax_note: 'تم حفظ الاعدادات ..\nيرجى اخذ العلم انه اذا قمت بتغيير الرقم الضريبي سيتوجب عليك اعادة تفعيل النسخة',
    sms_message: 'الرسالة النصية',
    search_by_customer_or_tax: 'البحث باسم العميل او رقم السجل أو الرقم الضريبي',
    send_message: 'إرسال رسالة',
    clients_list: 'قائمة العملاء',
    client: 'العميل',
    register_number: 'رقم السجل',
    domain: 'الدومين',
    last_invoice: 'آخر فاتورة',
    receive_messages: 'استقبال الرسائل',
    expiration_date: 'تاريخ الانتهاء',
    support_status: 'حالة الدعم',
    activity_status: 'الفعالية',
    edit_customer: 'تعديل عميل',
    add_message: 'إضافة رسالة',
    message_templates: 'قوالب الرسائل',
    updated_by: 'تعديل بواسطة',
    actions: 'الاجراءات',
    sms_messages: 'رسائل SMS',
    whatsapp_messages: 'رسائل Whatsapp',
    customer_source: 'مصدر العميل',
    manufacturer: 'الشركة المصنعة',
    manufacture_year: 'سنة الصنع',
    please_wait: 'يرجى الانتظار ... Please Wait',
    package_invoice_canceled_at: 'تم الغاء فاتورة الباقة بتاريخ',
    reason: 'وذلك بسبب',
    card_canceled_at: 'تم الغاء هذه البطاقة بتاريخ',
    cancel_reason: 'وسبب الالغاء',
    labor: 'العمالة',
    warning: 'تحذير',
    confirm: 'متأكد',
    confirm_cancel_invoice_warning: 'هل أنت متاكد بانك تريد الغاء هذه الفاتورة؟ لا يمكن التراجع عن هذا االاجراء',
    confirm_cancel_invoice: 'هل أنت متأكد بانك تريد الغاء الفاتورة؟',
    invoices_list: 'قائمة الفواتير',
    invoice_return_reason_required: 'يجب كتابة سبب ارجاع الفاتورة ويجب أن يكون اكثر من 10 حروف',
    select_cancel_reason: 'يرجى اختيار سبب الالغاء',
    cancel_reason_input_error: 'خطأ في الادخال',
    cancel_reason_service_issue: 'سوء الخدمة',
    cancel_reason_price: 'السعر غير مناسب',
    invoice_canceled_successfully: 'تم ارجاع الفاتورة بنجاح',
    confirm_delete: 'هل انت متأكد انك تريد حذف هذا الحساب؟',
    confirm_delete_continue: 'هل انت متاكد انك تريد متابعة الحذف',
    status_delete_warning: 'في حال تم حذف الحالة - مستخدمة في احد اقسام البرنامج .. يجب تعديل الحالات المستخدمة قبل المتابعة',
    accept_responsibility: 'اوافق على مسؤوليتي',
    image: 'صورة',
    file: 'ملف',
    video: 'فديو',
    upload_file_optional: 'أو بإمكانك تحميل ملف',
    all_cities: 'كل المدن',
    all_industries: 'كل الصناعيات',
    manual_send: 'ارسال يدوي',
    card_copy: 'نسخة من الكرت',
    invoice_copy: 'نسخة من الفاتورة',
    verification_code: 'كود التحقق',
    text_message: 'رسالة نصية',
    text_message_with_image: 'رسالة نصية مع صورة',
    text_message_with_document: 'رسالة نصية مع مستند',
    text_message_with_video: 'رسالة نصية مع فيديو',
    all_customers: 'كل العملاء',
    shipment_date: 'تاريخ الارسالية',
    sent_products: 'المنتجات المرسلة',
    total_sent: 'اجمالي المرسل',
    received_products: 'المنتجات المستلمة',
    total_received: 'اجمالي المستلم',
    returned_by: 'ارجاع بواسطة',
    add_shipment: 'اضافة ارسالية',
    product_update_save_note: 'تم التعديل بنجاح - لا تنسى ان تضغط زر حفظ حتى يتم اعتماد التعديل',
    mobile_format_invalid: 'رقم اتصال العميل يجب ان يكون عشرة ارقام يبدأ بـ 05',
    price_empty_warning: 'لا يمكن اضافة سعر فارغ يرجى اضافة السعر او رقم صفر',
    locking_invoice_warning: 'يرجى التنبيه : في حال اصدار الفاتورة لا يمكن اجراء اي تعديل على الفاتورة - يرجى التاكد من جميع البيانات داخل الفاتورة قبل اصدارها',
    item_type_label: 'نوع الصنف',
    unit_label: 'الوحدة',
    delete_button: 'حذف',
    insurance_label: 'تأمين',
    total_after_insurance: 'الاجمالي بعد التامين',
    unit_item_name: 'حبة',
    pay_more_than_invoiced: 'لا يمكن دفع قيمة اكبر من مبلغ الفاتورة',
    item_price_empty_warning: 'يجب اضافة السعر كرقم في خانة السعر في الاصناف او اضافة صفر اذا كان بدون قيمة',
    review_invoice: 'مراجعة الفاتورة',
    cancel_invoice: 'الغاء الفاتورة',
    issue_invoice: 'اصدار الفاتورة',
    nd_start_date: 'تاريخ البداية',
    nd_end_date: 'تاريخ النهاية',
    nd_branches: 'الفروع',
    nd_search: 'بحث',
    nd_finance_module: 'الوحدة المالية',
    nd_calendar_dashboard: 'تقويم لوحة التحكم',
    nd_calendar_type: 'نوع التقويم',
    nd_worker_tasks: 'مهام العمال',
    nd_delivery_cars: 'تسليم السيارات',
    nd_no_records: 'لا توجد بيانات ضمن الفترة المحددة.',
    nd_job_cards: 'بطاقات العمل',
    nd_work_orders: 'أوامر العمل',
    nd_job_orders: 'أوامر الشغل',
    nd_income_by: 'الإيراد حسب',
    nd_intervals: 'فترات',
    nd_expense_breakdown: 'تفصيل المصروفات',
    nd_total_expenses: 'إجمالي المصروفات',
    nd_sales_items: 'عناصر المبيعات',
    nd_extra_profit: 'ربح إضافي',
    nd_total_profit: 'إجمالي الربح',
    nd_total_income: 'إجمالي الإيراد',
    nd_total_salaries: 'إجمالي الرواتب',
    nd_total_purchase: 'إجمالي المشتريات',
    nd_revenue_or_loss: 'الإيراد / الخسارة',
    nd_payment_types: 'أنواع الدفع',
    nd_balance: 'الرصيد',
    nd_employee_financial_cards: 'بطاقات الموظفين المالية',
    nd_employees: 'موظفين',
    nd_salary: 'الراتب',
    nd_pay_advanced: 'السلف',
    nd_deductions: 'الخصومات',
    nd_net_paid_salary: 'صافي الراتب المدفوع',
    nd_branch_summary_income_expense: 'ملخص الفروع (إيراد مقابل مصروف)',
    nd_income: 'الإيراد',
    nd_expense: 'المصروف',
    nd_profit: 'الربح',
    nd_loss: 'الخسارة',
    nd_branch: 'الفرع',
    nd_total: 'الإجمالي',
    nd_month: 'شهر',
    nd_week: 'أسبوع',
    nd_day: 'يوم',
    nd_no_date: 'بدون تاريخ',
    nd_expired: 'منتهي',
    nd_expiring: 'ينتهي قريباً',
    nd_valid: 'ساري',
    nd_employee_labor_performance: 'أداء عمالة الموظفين',
    nd_working: 'العمل',
    nd_late: 'متأخر',
    nd_total_bill: 'إجمالي الفاتورة',
    nd_paid: 'المدفوع',
    nd_remaining: 'المتبقي',
    nd_vat: 'ضريبة القيمة المضافة',
    nd_view_details: 'عرض التفاصيل',
    nd_job_card_details: 'تفاصيل بطاقة العمل',
    nd_plate: 'اللوحة',
    nd_vehicle: 'المركبة',
    nd_customer: 'العميل',
    nd_mobile: 'الجوال',
    nd_card_id: 'رقم البطاقة',
    nd_received_date: 'الاستلام',
    nd_expected_date: 'المتوقع',
    nd_status: 'الحالة',
    nd_under_process: 'تحت الإجراء',
    nd_ready_to_collect: 'جاهز للاستلام',
    nd_closed: 'مغلق',
    nd_unknown: 'غير معروف',
    nd_unknown_branch: 'فرع غير معروف',
    nd_work_orders_employee_kpi: 'أوامر العمل / مؤشرات الموظفين',
    nd_attendance_collections: 'تجميع الحضور',
    nd_periods: 'فترات',
    nd_metric: 'المؤشر',
    nd_working_hours: 'ساعات العمل',
    nd_lates: 'التأخير',
    nd_non_attendance: 'عدم الحضور',
    nd_overtime: 'وقت إضافي',
    overtime: 'وقت إضافي',
    pay_overtime: 'سداد الإضافي',
    overtime_payment: 'سداد الوقت الإضافي',
    overtime_payment_failed: 'تعذر حفظ سداد الوقت الإضافي',
    full_payment: 'سداد كامل',
    partial_payment: 'سداد جزئي',
    payment: 'السداد',
    minutes: 'الدقائق',
    hours: 'الساعات',
    nd_rewards: 'المكافآت',
    nd_rewards_hint: 'مكافآت وتسويات أخرى (الوقت الإضافي وعدم الحضور يظهران بشكل منفصل)',
    nd_performance_rating: 'تقييم الأداء',
    nd_total_job_orders: 'إجمالي أوامر العمل',
    nd_on_progress: 'قيد التنفيذ',
    nd_finished: 'مكتمل',
    nd_recent_task_snapshot: 'ملخص المهام الأخيرة',
    nd_admin_notes: 'ملاحظات الإدارة',
    nd_add_admin_note: 'أضف ملاحظة إدارية...',
    nd_update_note: 'تحديث الملاحظة',
    nd_employee_tasks: 'مهام الموظف',
    nd_task_id: 'رقم المهمة',
    nd_task: 'المهمة',
    nd_due_date: 'تاريخ الاستحقاق',
    nd_all: 'الكل',
    nd_active: 'نشط',
    nd_on_break: 'في استراحة',
    nd_on_leave: 'في إجازة',
    nd_employee: 'الموظف',
    nd_tasks: 'مهام',
    nd_no_tasks_found: 'لا توجد مهام',
    nd_monthly: 'شهري',
    nd_weekly: 'أسبوعي',
    nd_daily: 'يومي',
    att_hr: 'الموارد البشرية',
    att_attendance: 'الحضور',
    att_attendance_exception_mgmt: 'إدارة الحضور والاستثناءات',
    att_daily_attendance_tracking: 'متابعة الحضور اليومية',
    att_date: 'التاريخ',
    att_employees: 'الموظفون',
    att_on_time: 'في الوقت',
    att_late: 'متأخر',
    att_absent: 'غائب',
    att_vacation: 'إجازة',
    att_exceptions: 'الاستثناءات',
    att_branch: 'الفرع',
    att_shift_start: 'بداية الدوام',
    att_actual_arrival: 'وقت الحضور الفعلي',
    att_shift_end: 'نهاية الدوام',
    att_actual_departure: 'وقت الانصراف الفعلي',
    att_not_attended: 'لم يحضر',
    att_overtime: 'وقت إضافي',
    att_overtime_minutes: 'دقائق الوقت الإضافي',
    att_absence_type: 'نوع الغياب',
    att_justification_type: 'نوع التبرير',
    att_reason: 'السبب',
    att_save_attendance: 'حفظ الحضور',
    att_required_field: 'حقل مطلوب',
    att_absence_type_required: 'نوع الغياب مطلوب',
    att_justification_type_required: 'نوع التبرير مطلوب',
    att_reason_required: 'السبب مطلوب',
    att_on_vacation: 'في إجازة',
    att_permission: 'إذن',
    att_present_on_time: 'حاضر وفي الوقت',
    att_late_justified: 'تأخير (مبرر)',
    att_late_early_unjustified: 'تأخير / انصراف مبكر (غير مبرر)',
    att_submit_success: 'تم إرسال الحضور بنجاح',
    att_backend_pending: 'واجهة الحفظ الخلفية غير جاهزة بعد، تم تسجيل البيانات',
    att_justified_delay: 'تأخير مبرر',
    att_justified_departure: 'انصراف مبكر مبرر',
    att_unjustified: 'غير مبرر',
    att_permission_approved_leave: 'إذن (إجازة معتمدة)',
    att_not_justified_absent: 'غير مبرر (غياب)',
    att_load_employees_failed: 'تعذر تحميل الموظفين',
    att_unknown_branch: 'فرع غير معروف',
    att_unknown_employee: 'موظف غير معروف',
    ti_quick_search: 'بحث سريع',
    ti_from_date: 'من تاريخ',
    ti_to_date: 'إلى تاريخ',
    ti_new_report: 'تقرير جديد',
    ti_report_header: 'تقرير فحص فني',
    ti_office_name: 'شيخ المهنة لتقدير الأضرار',
    ti_report_number: 'رقم التقرير',
    ti_date: 'التاريخ',
    ti_date_label: 'التاريخ (ميلادي/هجري)',
    ti_status: 'الحالة',
    ti_status_draft: 'مسودة',
    ti_status_issued: 'صادر',
    ti_status_final: 'نهائي',
    ti_vehicle: 'المركبة',
    ti_vehicle_type: 'نوع المركبة',
    ti_vehicle_model: 'موديل المركبة',
    ti_plate: 'اللوحة',
    ti_plate_number: 'رقم اللوحة',
    ti_claimant: 'المدعي',
    ti_claimant_name: 'اسم المدعي',
    ti_defendant: 'المدعى عليه',
    ti_defendant_name: 'اسم المدعى عليه',
    ti_commercial_register: 'السجل التجاري',
    ti_cr: 'س.ت',
    ti_labor_cost: 'أجرة العمل',
    ti_labor_cost_sar: 'أجرة العمل (ريال)',
    ti_labor_cost_numeric: 'أجرة العمل رقماً',
    ti_labor_cost_words: 'أجرة العمل كتابة',
    ti_status_condition: 'وصف الحالة',
    ti_party_to_replay: 'رد الطرف الثاني',
    ti_actions: 'إجراءات',
    ti_edit: 'تعديل',
    ti_delete: 'حذف',
    ti_preview_print: 'عرض/طباعة PDF',
    ti_add_report_title: 'إضافة تقرير فحص فني',
    ti_edit_report_title: 'تعديل تقرير فحص فني',
    ti_step_vehicle: 'معلومات المركبة',
    ti_step_parties: 'أطراف الدعوى',
    ti_step_findings: 'النتائج الفنية',
    ti_step_cost_status: 'التكلفة والحالة',
    ti_findings_title: 'المعاينات والنتائج الفنية',
    ti_add_item: 'إضافة بند',
    ti_item: 'البند',
    ti_save_report: 'حفظ التقرير',
    ti_confirm_delete_title: 'تأكيد الحذف',
    ti_confirm_delete_text: 'هل أنت متأكد من حذف التقرير رقم',
    ti_yes_delete: 'نعم، حذف',
    ti_section_vehicle: 'أولاً: بيانات المركبة',
    ti_section_parties: 'ثانياً: أطراف الدعوى',
    ti_section_findings: 'ثالثاً: النتائج الفنية',
    ti_section_financial: 'رابعاً: التقدير المالي',
    ti_type: 'النوع',
    ti_model: 'الموديل',
    ti_signature_expert: 'خبير الفحص الفني',
    ti_signature_approval: 'اعتماد شيخ المهنة',
    ti_name_signature: 'الاسم والتوقيع',
    ti_load_failed: 'تعذر تحميل تقارير الفحص الفني',
    ti_success_title: 'نجاح',
    ti_add_success: 'تم إضافة التقرير بنجاح',
    ti_update_success: 'تم تحديث التقرير بنجاح',
    ti_save_failed: 'تعذر حفظ التقرير',
    ti_delete_success: 'تم حذف التقرير بنجاح',
    ti_delete_failed: 'تعذر حذف التقرير',
    currency_code: 'ريال',
    manage_workers: 'إدارة العمال',
    nd_full_page: 'ملء الشاشة',
    nd_back: 'رجوع',
    zi_title: 'الربط مع هيئة الزكاة والضريبة',
    zi_tab_status: 'الحالة',
    zi_tab_profile: 'بيانات البائع',
    zi_tab_connect: 'ربط جهاز',
    zi_tab_documents: 'سجل الإرسال',
    zi_mode: 'طريقة الإرسال',
    zi_mode_off: 'متوقف',
    zi_mode_phase1: 'المرحلة الأولى (رمز QR فقط)',
    zi_mode_central: 'عبر الخادم المركزي (الطريقة القديمة)',
    zi_mode_inapp: 'من داخل النظام (المرحلة الثانية)',
    zi_environment: 'البيئة',
    zi_env_simulation: 'بيئة المحاكاة',
    zi_env_core: 'البيئة الفعلية',
    zi_devices: 'الأجهزة المربوطة',
    zi_no_devices: 'لا يوجد جهاز مربوط بعد',
    zi_branch: 'الفرع',
    zi_status: 'الحالة',
    zi_source: 'المصدر',
    zi_cert_expires: 'انتهاء الشهادة',
    zi_days_left: 'يوم متبقي',
    zi_icv: 'عداد الفواتير',
    zi_renew: 'تجديد الشهادة',
    zi_renew_help: 'أدخل رمز OTP جديد من بوابة فاتورة لتجديد الشهادة قبل انتهائها',
    zi_counts: 'الفواتير حسب الحالة',
    zi_oldest: 'أقدم فاتورة لم ترسل',
    zi_hours_old: 'ساعة',
    zi_overdue: 'تنبيه: الفواتير المبسطة يجب إبلاغ الهيئة بها خلال 24 ساعة من إصدارها',
    zi_key_missing: 'مفتاح التشفير ZATCA_KEY غير مضبوط على الخادم، لذلك لا يمكن ربط جهاز',
    zi_schema_missing: 'جداول الربط غير موجودة في قاعدة البيانات. شغل ملف الترحيل zatca_schema.sql',
    zi_central_note: 'هذه المنشأة ما زالت ترسل عبر الخادم المركزي. يتم نقلها بأداة الاستيراد مع الحفاظ على تسلسل الفواتير والشهادة الحالية.',
    zi_activate: 'بدء الإرسال من داخل النظام',
    zi_activate_confirm: 'من الآن سيتم توقيع كل فاتورة جديدة وإرسالها إلى هيئة الزكاة. متابعة؟',
    zi_zero_title: 'البنود بنسبة ضريبة 0%',
    zi_zero_help: 'مطلوب فقط إذا كانت لديكم بنود بنسبة 0%. بدونها لن ترسل الفاتورة',
    zi_zero_category: 'الفئة',
    zi_zero_code: 'رمز سبب الإعفاء',
    zi_zero_text: 'نص سبب الإعفاء',
    zi_save: 'حفظ',
    zi_saved: 'تم الحفظ',
    zi_seller_name_en: 'اسم المنشأة بالإنجليزي',
    zi_seller_name_ar: 'اسم المنشأة بالعربي',
    zi_vat: 'الرقم الضريبي',
    zi_crn: 'رقم السجل التجاري',
    zi_street: 'الشارع (بالإنجليزي)',
    zi_building: 'رقم المبنى',
    zi_secondary: 'الرقم الفرعي',
    zi_district: 'الحي (بالإنجليزي)',
    zi_city: 'المدينة (بالإنجليزي)',
    zi_postal: 'الرمز البريدي',
    zi_category: 'نشاط المنشأة',
    zi_profile_complete: 'بيانات البائع مكتملة',
    zi_profile_help: 'هذه البيانات تكتب في شهادة الجهاز وفي كل فاتورة. الاسم والعنوان بالإنجليزي كما هي في منصة فاتورة',
    zi_step1: 'إنشاء طلب الشهادة (CSR)',
    zi_step2: 'شهادة الامتثال برمز OTP من بوابة فاتورة',
    zi_step3: 'اختبارات الامتثال (6 فواتير تجريبية)',
    zi_step4: 'الشهادة الإنتاجية',
    zi_run: 'تنفيذ',
    zi_otp: 'رمز OTP',
    zi_passed: 'ناجح',
    zi_failed: 'فشل',
    zi_connected: 'تم ربط الجهاز. اضغط بدء الإرسال في تبويب الحالة',
    zi_doc_type: 'النوع',
    zi_invoice: 'فاتورة',
    zi_return: 'مرتجع',
    zi_number: 'الرقم',
    zi_subtype: 'التصنيف',
    zi_standard: 'ضريبية',
    zi_simplified: 'مبسطة',
    zi_attempts: 'المحاولات',
    zi_message: 'الخطأ / التحذير',
    zi_date: 'التاريخ',
    zi_resend: 'إعادة إرسال',
    zi_xml: 'تنزيل XML',
    zi_all: 'الكل',
    zi_search: 'بحث برقم الفاتورة',
    zi_from: 'من تاريخ',
    zi_to: 'إلى تاريخ',
    zi_prev: 'السابق',
    zi_next: 'التالي',
    zi_confirm: 'تأكيد',
    zi_cancel: 'إلغاء',
    zi_close: 'إغلاق',
    zi_st_unsigned: 'لم توقع',
    zi_st_pending: 'بانتظار الإرسال',
    zi_st_reported: 'تم الإبلاغ',
    zi_st_cleared: 'تم الاعتماد',
    zi_st_rejected: 'مرفوضة',
    zi_st_failed: 'فشل الإرسال',
    zi_st_imported: 'أرسلت سابقا',
    zi_st_draft: 'طلب شهادة',
    zi_st_compliance: 'شهادة امتثال',
    zi_st_active: 'مربوط',
    zi_v_title: 'لا يمكن حفظ الفاتورة قبل تصحيح ما يلي (متطلبات هيئة الزكاة):',
    zi_v_line: 'السطر',
    zi_v_no_lines: 'الفاتورة بدون أصناف',
    zi_v_line_name_missing: 'اسم الصنف فارغ',
    zi_v_line_qty_invalid: 'الكمية يجب أن تكون أكبر من صفر',
    zi_v_line_amount_mismatch: 'الكمية × السعر = {expected} لكن إجمالي السطر {actual}',
    zi_v_line_vat_rate_unknown: 'نسبة الضريبة {actual}% غير معروفة (المسموح 15% أو 5% أو 0%)',
    zi_v_line_vat_mismatch: 'الضريبة يجب أن تكون {expected} وهي {actual}',
    zi_v_line_ftotal_mismatch: 'الإجمالي مع الضريبة يجب أن يكون {expected} وهو {actual}',
    zi_v_zero_rate_not_configured: 'يوجد صنف بضريبة 0% ولم تحدد فئة الضريبة الصفرية في شاشة الربط مع الزكاة',
    zi_v_total_exceeds_lines: 'إجمالي الفاتورة قبل الضريبة {actual} أكبر من مجموع الأصناف {expected}',
    zi_v_vat_mismatch: 'ضريبة الفاتورة يجب أن تكون {expected} (بعد الخصم) وهي {actual}',
    zi_v_ftotal_mismatch: 'إجمالي الفاتورة مع الضريبة يجب أن يكون {expected} وهو {actual}',
    zi_v_discount_exceeds: 'الخصم أكبر من قيمة الأصناف',
    zi_v_credit_note_parent_missing: 'المرتجع غير مرتبط بفاتورة أصلية',
    zi_v_buyer_vat_invalid: 'الرقم الضريبي للعميل غير صحيح (15 رقما يبدأ وينتهي بالرقم 3)',
    zi_v_buyer_name_missing: 'اسم العميل مطلوب في الفاتورة الضريبية',
    zi_v_buyer_building_invalid: 'رقم مبنى العميل مطلوب (4 أرقام)',
    zi_v_buyer_street_missing: 'اسم شارع العميل مطلوب',
    zi_v_buyer_district_missing: 'حي العميل مطلوب',
    zi_v_buyer_city_missing: 'مدينة العميل مطلوبة',
    zi_v_buyer_postal_invalid: 'الرمز البريدي للعميل مطلوب (5 أرقام)',
    zi_v_buyer_secondary_invalid: 'الرقم الفرعي للعميل يجب أن يكون 4 أرقام',
    zi_v_no_device: 'لا يوجد جهاز مربوط بهيئة الزكاة لهذا الفرع',
    zi_st_needs_data: 'تحتاج تصحيح',
    zi_st_awaiting_clearance: 'بانتظار اعتماد الهيئة',
    zi_page_title: 'فواتير هيئة الزكاة',
    zi_page_help: 'كل فاتورة ومرتجع وحالتها لدى هيئة الزكاة. الفواتير التي تحتاج تصحيح أو رفضتها الهيئة يمكن تصحيح بياناتها وإعادة إرسالها من هنا',
    zi_grp_all: 'الكل',
    zi_grp_sent: 'تم إرسالها',
    zi_grp_waiting: 'بانتظار الإرسال',
    zi_grp_attention: 'تحتاج إجراء',
    zi_customer: 'العميل',
    zi_total: 'الإجمالي مع الضريبة',
    zi_reason: 'السبب',
    zi_erp_check: 'فحص النظام',
    zi_zatca_says: 'رد هيئة الزكاة',
    zi_fix: 'تصحيح',
    zi_fix_title: 'تصحيح الفاتورة وإعادة إرسالها',
    zi_buyer: 'بيانات العميل',
    zi_buyer_name: 'اسم العميل',
    zi_items: 'أسماء الأصناف',
    zi_save_resend: 'حفظ وإعادة الإرسال',
    zi_amounts_locked: 'المبالغ (الكميات والأسعار والضريبة) لا تعدل هنا لأنها مسجلة في القيد المحاسبي والمخزون. إذا كانت خاطئة أصدر مرتجعا ثم فاتورة جديدة صحيحة',
    zi_now: 'الحالة الآن',
    zi_still_problems: 'ما زالت هناك مشكلات',
    card_payment_invalid: "أدخل مبلغ سداد صحيحاً أكبر من صفر وبحد أقصى منزلتين عشريتين، وتأكد من فتح بطاقة صالحة.",
    card_payment_failed: "لم يتم حفظ الدفعة. تحقق من البيانات وحاول مرة أخرى.",
    card_payment_unconfirmed: "تعذر تأكيد حفظ الدفعة بسبب مشكلة في الاتصال. أعد فتح البطاقة وتحقق من الدفعات قبل إعادة السداد.",
    card_payment_refresh_failed: "تم حفظ الدفعة، لكن تعذر تحديث البطاقة. أعد فتحها لعرض الرصيد الجديد ولا تكرر السداد.",
    spare_request_no_data: "لا توجد طلبات",
    spare_request_availability: "توفر القطعة",
    spare_request_in_stock: "متوفر في المخزون",
    spare_request_out_of_stock: "غير متوفر في المخزون",
    spare_request_manual_review: "يتطلب مراجعة يدوية",
    spare_request_approve: "اعتماد",
    spare_request_send_customer: "غير مشمول - إرسال إلى العميل",
    spare_request_create_bill: "تسجيل الطلب كتم طلبه / ربط فاتورة",
    spare_request_waiting_customer: "بانتظار رد العميل",
    spare_request_customer_provided: "أحضر العميل القطعة",
    spare_request_back_pending: "إعادة إلى قيد الانتظار",
    spare_request_status_pending: "قيد الانتظار",
    spare_request_status_approved: "معتمد",
    spare_request_status_rejected: "مرفوض",
    spare_request_status_ordered: "تم الطلب",
    spare_request_status_fulfilled: "تم الاستلام",
    spare_request_status_awaiting_customer: "بانتظار العميل",
    spare_request_status_customer_will_provide: "سيحضر العميل القطعة",
    spare_request_confirm_reopen: "هل تريد إعادة هذا الطلب إلى قيد الانتظار لاعتماده أو رفضه مرة أخرى؟",
    spare_request_bill_id_prompt: "أدخل رقم سجل فاتورة الشراء (اختياري). اتركه فارغاً لتسجيل الطلب دون ربطه بفاتورة.",
    spare_request_price_prompt: "أدخل السعر المطلوب من العميل لهذه القطعة (ريال سعودي):",
    spare_request_invalid_price: "أدخل سعراً صحيحاً أكبر من صفر.",
    spare_request_confirm_essential: "هل هذه القطعة ضرورية لإكمال العمل (بحيث لا يمكن للعميل رفضها دون بديل)؟\n\nموافق = نعم، ضرورية\nإلغاء = لا، اختيارية",
    spare_request_send_failed: "تعذر إرسال طلب الموافقة إلى العميل.",
    spare_request_confirm_provided: "هل تؤكد أن العميل أحضر هذه القطعة بنفسه؟ سيتم اعتماد الطلب لتسليم القطعة إلى الفني.",
    checkup_plate_loading: "جارٍ البحث عن السيارة…",
    checkup_plate_found: "تم العثور على السيارة وتعبئة بياناتها في الحقول الفارغة.",
    checkup_plate_not_found: "لم يتم العثور على السيارة؛ يمكنك إدخال بياناتها.",
    checkup_plate_ambiguous: "توجد أكثر من سيارة بهذه اللوحة؛ تحقق من السجلات قبل تعبئة البيانات.",
    checkup_plate_failed: "تعذر البحث عن السيارة. تحقق من الاتصال وأعد المحاولة بالخروج من حقل اللوحة.",
    system_login_label: "تسجيل دخول",
    system_login_invalid: "اسم المستخدم أو كلمة المرور غير صحيحة.",
    system_login_unavailable: "تعذر الاتصال بالنظام. تحقق من الاتصال وحاول مرة أخرى.",
    purchase_vendor_id_optional: "رقم المورد (اختياري للبحث)",
    purchase_vendor_required: "أدخل رقم الفاتورة والأصناف. للمورد الجديد، الاسم ورقم الاتصال مطلوبان؛ رقم المورد غير مطلوب.",
    purchase_vendor_lookup_failed: "تعذر البحث عن المورد. تحقق من الاتصال وأعد البحث برقم المورد أو رقم الاتصال.",
    purchase_number_duplicate: "رقم الفاتورة مستخدم مسبقاً لهذا المورد. لم يتم إنشاء فاتورة أخرى.",
    purchase_save_failed: "لم يتم حفظ فاتورة الشراء. تحقق من البيانات وحاول مرة أخرى.",
    purchase_unconfirmed: "تعذر تأكيد حفظ فاتورة الشراء. تحقق من قائمة الفواتير قبل إعادة الحفظ.",
    purchase_refresh_failed: "تم حفظ فاتورة الشراء، لكن تعذر تحديث القائمة. أعد فتح القائمة ولا تكرر الحفظ.",
    zi_view: 'عرض'
  }

  export default arLang;
